webpackJsonp([1],{

/***/ "0b5j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"size":"md","hide-footer":""},model:{value:(_vm.signUpModal),callback:function ($$v) {_vm.signUpModal=$$v},expression:"signUpModal"}},[_c('div',{attrs:{"slot":"modal-header"},slot:"modal-header"},[_c('svg',{attrs:{"version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","preserveAspectRatio":"xMidYMid meet","viewBox":"0 350 500 250","height":"50"}},[_c('defs',[_c('path',{attrs:{"d":"M150 448.33L150 598.33L0 598.33L0 348.33L50 348.33L50 448.33L150 448.33ZM275 498.33L275 598.33L225 598.33L225 498.33L175 498.33L175 448.33L325 448.33L325 498.33L275 498.33ZM500 498.33L400 498.33L400 598.33L350 598.33L350 448.33L500 448.33L500 498.33ZM50 548.33L100 548.33L100 498.33L50 498.33L50 548.33Z","id":"logo"}})]),_vm._v(" "),_c('g',[_c('use',{staticClass:"logosvg",attrs:{"xlink:href":"#logo"}})])])]),_vm._v(" "),_c('b-form-input',{attrs:{"id":"email","placeholder":"Enter Email","state":_vm.emailValid,"type":"email"},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-form-input',{attrs:{"id":"password","placeholder":"Enter Password","state":_vm.checkPassword,"type":"password"},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-form-input',{attrs:{"id":"confirmPassword","placeholder":"Confirm Password","state":_vm.comparePasswords,"type":"password"},model:{value:(_vm.confirmPassword),callback:function ($$v) {_vm.confirmPassword=$$v},expression:"confirmPassword"}}),_vm._v("\n  "+_vm._s(_vm.comparePasswords)+_vm._s(_vm.errorText)+"   \n\n  "),_c('div',{staticClass:"text-center"},[_c('b-btn',{staticClass:"mt-3",attrs:{"disabled":!_vm.formValid,"variant":"outline-warning","size":"lg"},on:{"click":_vm.emailSignUp}},[_vm._v("Sign Up")]),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"outline-danger","size":"lg"},on:{"click":function($event){_vm.$emit('close')}}},[_vm._v("Cancel")]),_vm._v(" "),_c('br'),_vm._v("    \n        By continuing you Accept our "),_c('router-link',{attrs:{"to":"terms","target":"_blank"}},[_vm._v("Terms of use ")])],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('b-btn',{on:{"click":_vm.googleSignIn}},[_c('font-awesome-icon',{staticClass:"socialicon",attrs:{"icon":['fab', 'google'],"size":"1x"}}),_vm._v("  Continue with Google")],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1/oy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1j2Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"justify-content-md-center"},[_c('b-col',{attrs:{"cols":"8"}},[_c('h1',[_vm._v("Disclaimer")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',[_vm._v("This document was created using a Contractology template available at http://www.contractology.com.")]),_vm._v(" "),_c('h5',[_vm._v("No warranties")]),_vm._v(" "),_c('p',[_vm._v("This website is provided “as is” without any representations or warranties, \n          express or implied. BTR Works makes no representations or warranties in \n          relation to this website or the information and materials provided on this \n          website.  ")]),_vm._v(" "),_c('p',[_vm._v("Without prejudice to the generality of the foregoing paragraph, \n          BTR Works does not warrant that: ")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("this website will be constantly available, or available at all; or ")]),_vm._v(" "),_c('li',[_vm._v("the information on this website is complete, true, accurate or non-misleading.")])]),_vm._v(" "),_c('p',[_vm._v("Nothing on this website constitutes, or is meant to constitute, advice of any kind. \n          If you require advice in relation to any legal or financial matter \n          you should consult an appropriate professional.")]),_vm._v(" "),_c('h5',[_vm._v("Limitations of liability")]),_vm._v(" "),_c('p',[_vm._v("BTR Works will not be liable to you (whether under the law of \n            contract, the law of torts or otherwise) in relation to the \n            contents of, or use of, or otherwise in connection with, \n            this website: ")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("to the extent that the website is provided free-of-charge, for any direct loss;")]),_vm._v(" "),_c('li',[_vm._v("for any indirect, special or consequential loss; or ")]),_vm._v(" "),_c('li',[_vm._v("for any business losses, loss of revenue, income, profits or anticipated savings, loss of contracts or business relationships, loss of reputation or goodwill, or loss or corruption of information or data.")])]),_vm._v(" "),_c('p',[_vm._v("These limitations of liability apply even if BTR Works has been expressly advised of the potential loss.")]),_vm._v(" "),_c('h5',[_vm._v("Exceptions")]),_vm._v(" "),_c('p',[_vm._v("Nothing in this website disclaimer will exclude or limit any warranty implied by law that it would be unlawful to exclude or limit; \n            and nothing in this website disclaimer will exclude or limit BTR Works liability in respect of any:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("death or personal injury caused by BTR Works’ negligence;")]),_vm._v(" "),_c('li',[_vm._v("fraud or fraudulent misrepresentation on the part of BTR Works; or ")]),_vm._v(" "),_c('li',[_vm._v("matter which it would be illegal or unlawful for BTR Works to exclude or limit, or to attempt or purport to exclude or limit, its liability. ")])]),_vm._v(" "),_c('h5',[_vm._v("Reasonableness")]),_vm._v(" "),_c('p',[_vm._v("By using this website, you agree that the exclusions and limitations of liability set out in this website disclaimer are reasonable.  ")]),_vm._v(" "),_c('p',[_vm._v("If you do not think they are reasonable, you must not use this website.")]),_vm._v(" "),_c('h5',[_vm._v("Other parties")]),_vm._v(" "),_c('p',[_vm._v("You accept that, as a limited liability entity, \n            BTR Works has an interest in limiting the personal liability of its officers \n            and employees.  You agree that you will not bring any claim personally \n            against BTR Works’ officers or employees in respect of any losses you suffer \n            in connection with the website.")]),_vm._v(" "),_c('p',[_vm._v("Without prejudice to the foregoing paragraph, \n            you agree that the limitations of warranties and \n            liability set out in this website disclaimer will protect\n            BTR Works’ officers,\n            employees, agents, subsidiaries, successors, assigns and \n            sub-contractors as well as BTR Works. ")]),_vm._v(" "),_c('h5',[_vm._v("Unenforceable provisions")]),_vm._v(" "),_c('p',[_vm._v("If any provision of this website disclaimer is, or is found to be, \n            unenforceable under applicable law, that will not affect the \n            enforceability of the other provisions of this website disclaimer.")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1tfX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-row',[_c('b-col',{staticClass:"my-4 center",attrs:{"cols":"12"}},[((_vm.user))?_c('h2',[_vm._v("Hi, "+_vm._s(_vm.user.displayName || _vm.user.email))]):_vm._e(),_vm._v(" "),_c('h2',[_vm._v("Let us send you some Happiness (Happy) Token to your Ethereum Wallet")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-input-group',{attrs:{"size":"lg","prepend":"Ethereum Wallet Address"}},[_c('b-input',{attrs:{"placeholder":_vm.walletComment,"readonly":!_vm.user || _vm.tokenRequested},model:{value:(_vm.ethAdd),callback:function ($$v) {_vm.ethAdd=$$v},expression:"ethAdd"}}),_vm._v(" "),_c('b-input-group-append',[_c('b-btn',{attrs:{"disabled":!_vm.user|| _vm.tokenRequested,"variant":"warning"},on:{"click":_vm.requestHappy}},[_vm._v(_vm._s(_vm.happyButton))])],1)],1),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('br'),_vm._v("   \n     By proceeding you accept the  "),_c('router-link',{attrs:{"to":"happyterms","target":"_blank"}},[_vm._v(" Terms and Conditions ")]),_vm._v(" of the Happiness Tokens   \n    ")],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "24tJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_btr_happy_vue__ = __webpack_require__("7Qmh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e75cf996_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_btr_happy_vue__ = __webpack_require__("dlQ+");
function injectStyle (ssrContext) {
  __webpack_require__("LsxN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e75cf996"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_btr_happy_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e75cf996_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_btr_happy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2g8o":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3eXR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_btr_social_vue__ = __webpack_require__("4hOa");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9dd586b6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_btr_social_vue__ = __webpack_require__("7Sv2");
function injectStyle (ssrContext) {
  __webpack_require__("ZT1f")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9dd586b6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_btr_social_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9dd586b6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_btr_social_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3rUv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_vue__ = __webpack_require__("LdjY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dcb4818a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_login_vue__ = __webpack_require__("BEV9");
function injectStyle (ssrContext) {
  __webpack_require__("erN2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-dcb4818a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dcb4818a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "42Im":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4hOa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_components_Icon__ = __webpack_require__("D4uH");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {},
  components: __WEBPACK_IMPORTED_MODULE_0_vue_awesome_components_Icon__["a" /* default */],
  data: function data() {
    return {};
  },
  computed: {},
  created: function created() {},

  methods: {},
  mounted: function mounted() {}
});

/***/ }),

/***/ "52fR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import Chart from 'chart.js'

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    content: '',
    user: {
      default: {
        displayName: 'hello'
      }
    }
  },
  data: function data() {
    return {
      status: 'updated'
    };
  },

  computed: {},
  created: function created() {},

  methods: {
    happyClick: function happyClick() {
      console.log('Splash Happyclick');
      this.$emit('close-splash', { splashContent: 'happyoffer', splashBox: true });
    },

    closeBox: function closeBox() {
      console.log('emit event to close about box', true);
      this.$emit('close-splash', { splashContent: 'none', splashBox: false });
    }
  },
  mounted: function mounted() {}
});

/***/ }),

/***/ "56gR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5TPd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (value) {
  var date = new Date(value);
  return date.toLocaleString('en-US', { month: 'short', day: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' });
});

/***/ }),

/***/ "7CU6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7Qmh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import Chart from 'chart.js'

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['wallet'],
  data: function data() {
    return {
      happy: {
        level: 'Grab Some',
        amount: 0
      },
      status: 'updated',
      apiresponse: ''
    };
  },
  watch: {
    wallet: function wallet() {
      this.getHappy(this.wallet);
    }
  },
  created: function created() {
    console.log('IAMHERE');
    this.getHappy(this.wallet);
  },

  methods: {
    getHappy: function getHappy(address) {
      var _this = this;

      var url = 'https://api.ethplorer.io/getAddressInfo/' + address + '?apiKey=freekey';
      console.log('this Address:', url);
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url).then(function (response) {
        _this.apiresponse = response.data.tokens;
        console.log('APIDATA', _this.apiresponse);
        for (var i = 0; i < _this.apiresponse.length; i++) {
          console.log('Token:', i, _this.apiresponse[i]);
          if (_this.apiresponse[i].tokenInfo.address === '0x5a567e28dbfa2bbd3ef13c0a01be114745349657') {
            _this.happy.amount = _this.apiresponse[i].balance / 100;
            _this.happy.level = 'Got Some';
          } else {
            _this.happy.amount = 0;
            _this.happy.level = 'Need Some';
          }
        }
        return _this.apiresponse;
      }).catch(function (error) {
        console.log(error);
        return error;
      });
    }
  },
  mounted: function mounted() {
    // const ctx = document.getElementById(this.title)
    // this.myChart = new Chart(ctx, this.chartdata)
    // console.log('initial:', this.chartdata.data)
  }
});

/***/ }),

/***/ "7Sv2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{attrs:{"href":"https://t.me/btrworks"}},[_c('font-awesome-icon',{staticClass:"socialicon",attrs:{"icon":['fab', 'telegram-plane'],"size":"2x"}})],1),_vm._v(" "),_c('a',{staticClass:"twitter-share-button",attrs:{"href":"https://twitter.com/intent/tweet?text=Get%20Happiness&hashtags=btrworks&url=https://happy.btr.works","data-size":"large"}},[_c('font-awesome-icon',{staticClass:"socialicon",attrs:{"icon":['fab', 'twitter'],"size":"2x"}})],1),_vm._v(" "),_c('a',{attrs:{"href":"https://www.facebook.com/btrworkscom"}},[_c('font-awesome-icon',{staticClass:"socialicon",attrs:{"icon":['fab', 'facebook'],"size":"2x"}})],1),_vm._v(" "),_c('a',{attrs:{"href":"https://www.youtube.com/channel/UCjdXiMBGTm0dVtEP_fim9Zw"}},[_c('font-awesome-icon',{staticClass:"socialicon",attrs:{"icon":['fab', 'youtube'],"size":"2x"}})],1),_vm._v(" "),_c('a',{attrs:{"href":"https://plus.google.com/b/115066573036854573232/115066573036854573232"}},[_c('font-awesome-icon',{staticClass:"socialicon",attrs:{"icon":['fab', 'google-plus-square'],"size":"2x"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8oj4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"justify-content-md-center"},[_c('b-col',{attrs:{"cols":"8"}},[_c('h1',[_vm._v("Donate")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',[_vm._v(" These tools are here for you to use freely. If you find them useful please consider donating a bit of crypto to help pay for development. Thanks for your support!\n          ")]),_c('hr'),_vm._v(" "),_c('h5',[_vm._v("BTC\t- 3BBRymPGZLx8BNw5NFFCHEDqV2bXpYgbJ7")]),_vm._v(" "),_c('h5',[_vm._v("LTC\t- MHpnJhv3oY9VHd5iMRYaUnsy5W4PJLViYz")]),_vm._v(" "),_c('h5',[_vm._v("ETH\t- 0xdDfad5e5d4eE3E1C0435aE13e393355c7E5cf3fC")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',[_vm._v(" Using our affiliate links also helps us to continue development of this site. If you're interested in buying a hardware wallet or signing up for a crypto exchange account, please consider using one of the links below.\n          ")]),_c('hr'),_vm._v(" "),_c('h4',[_vm._v("Turn your Dollars into Bitcoin")]),_vm._v(" "),_c('h4',[_c('a',{attrs:{"href":"https://www.coinbase.com/join/5a7e51ce29d0e901586c3e50"}},[_vm._v(" Coinbase ")])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h4',[_vm._v("Turn your Bitcoin into Altcoins")]),_vm._v(" "),_c('h4',[_c('a',{attrs:{"href":"https://www.binance.com/?ref=26782397"}},[_vm._v("Binance ")])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h4',[_vm._v("Keep your Crypto Safe in your Pocket")]),_vm._v(" "),_c('h4',[_c('a',{attrs:{"href":"https://www.ledgerwallet.com/r/1d2e"}},[_vm._v(" Ledger ")])]),_vm._v(" "),_c('hr')])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9M+g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9wwn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__("kxiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_components_Icon__ = __webpack_require__("D4uH");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import { erc20ABI } from '@/helpers/ERC20ABI'

// import Web3 from 'web3'
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    user: {
      default: {
        displayName: 'hello'
      }
    }
  },
  name: 'hello',
  components: __WEBPACK_IMPORTED_MODULE_1_vue_awesome_components_Icon__["a" /* default */],

  data: function data() {
    return {
      // walletComment: 'Sign In to Add Wallet Address',
      happyButton: 'Send',
      userSettings: [],
      events: [],
      status: '',
      address: 'https://mainnet.infura.io/v3/982307e2834b4d189a08c2f4fbb9f44f',
      contractAdd: '0x2c2ac8ab03f9720ae5d3bdda57320d11ce2b082b', // ziggy main net
      ethAdd: '',
      msg: 'Welcome to Your Vue.js App',
      balance: '',
      tokenName: '',
      tokenSymbol: '',
      tokenBalance: '',
      totalSupply: '',
      tokenRequested: false
    };
  },


  computed: {
    walletComment: function walletComment() {
      if (this.user) {
        if (this.tokenRequested) {
          this.happyButton = 'Pending';
          return 'Pending Delivery of Happiness'; // signed in and requested
        } else {
          this.happyButton = 'Send';
          return ' Add Wallet Address '; // Signed in
        }
      } else {
        this.happyButton = 'Send';
        return ' Sign in to Add Wallet Address'; // Not Signed in
      }
    }
  },
  methods: {
    loadUserSettings: function loadUserSettings() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_firebase__["database"]().ref('/user/' + this.user.uid + '/settings/').once('value').then(function (data) {
        if (data.val()) {
          _this.userSettings = data.val(); // push the loaded stuff to local user assets
          console.log('Got User Settings', _this.userSettings);
        } else {
          _this.saveUserSettings(); // or if there is no data save whatever is in the local state to the database
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    loadUserEvents: function loadUserEvents() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_firebase__["database"]().ref('/user/' + this.user.uid + '/events/').once('value').then(function (data) {
        if (data.val()) {
          var obj = data.val();
          var records = [];
          for (var key in obj) {
            records.push({
              id: key,
              description: obj[key].description,
              type: obj[key].type,
              payload: obj[key].payload,
              date: obj[key].date
            });
          }
          _this2.events = records; // push the loaded stuff to local user assets
          console.log('Got User Events', _this2.events);
          _this2.checkEvents();
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    loadUserPortfolio: function loadUserPortfolio() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0_firebase__["database"]().ref('/user/' + this.user.uid + '/portfolio/').once('value').then(function (data) {
        if (data.val()) {
          console.log('Got User Data', data.val());
          // this.trashCollect()  // clear out what ever is there
          _this3.user.assets = data.val(); // push the loaded stuff to local user assets
          // this.setupSockets() // set up new sockets
        } else {
            // this.saveUserData() // or if there is no data save whatever is in the local state to the database
          }
      }).catch(function (error) {
        console.log(error);
      });
    },
    requestHappy: function requestHappy() {
      var _this4 = this;

      var d = new Date();
      var eventData = {
        date: d.toString(),
        type: 'request',
        description: 'Happy Token Promo 2018',
        payload: {
          ethAddress: this.ethAdd
        },
        status: 'Pending'
        // this.events.push(eventData)
      };console.log('Requesting via Event:', eventData);
      __WEBPACK_IMPORTED_MODULE_0_firebase__["database"]().ref('/user/' + this.user.uid + '/events/').push(eventData).then(function (data) {
        console.log('Returned:', data);
      }).catch(function (error) {
        console.log(error);
      });
      var wallet = {
        name: 'Etherium',
        type: 'Etherium',
        address: this.ethAdd
      };
      __WEBPACK_IMPORTED_MODULE_0_firebase__["database"]().ref('/user/' + this.user.uid + '/wallets').push(wallet).then(function (data) {
        console.log('Added Address:', _this4.ethAdd);
        _this4.happyRequestAck(_this4.ethAdd);
      }).catch(function (error) {
        console.log(error);
      });
    },
    checkEvents: function checkEvents() {
      console.log('Checking Events');
      var record = '';
      for (var i = 0; i < this.events.length; i++) {
        record = this.events[i];
        console.log('Event:', i, record);
        // this.walletComment = 'Add Wallet Address'
        this.happyButton = 'Send';
        this.tokenRequested = false;
        if (record.description === 'Happy Token Promo 2018') {
          this.tokenRequested = true;
        }
      }
    },
    happyRequestAck: function happyRequestAck(address) {
      console.log('Acknowledged Request to Deposit Happy to Eth:', this.ethAdd);
      this.ethAdd = '';
      this.loadUserSettings();
      this.loadUserEvents();
      this.tokenRequested = true;
      // this.walletComment = 'Happiness Request'
      // this.happyButton = 'Pending'
    }
    //   getETHBalance () {
    //     console.log('Address:', this.address)
    //     console.log('Eth Address:', this.ethAdd)
    //     var query = new Web3(this.address)
    //     query.eth.getBalance(this.ethAdd, (error, wei) => {
    //       if (error) {
    //         console.log('Unknown Error')
    //         return
    //       }
    //       this.balance = Web3.utils.fromWei(wei, 'ether')
    //     })
    //   },
    //   getContractBalance () {
    //     console.log('Getting Contract Balance:', this.contractAdd)
    //     var query = new Web3(this.address)
    //     var contract = new query.eth.Contract(this.ERC20ABI, this.contractAdd)
    //     console.log('Contract', contract)
    //     contract.methods.balanceOf(this.ethAdd).call((error, result) => {
    //       if (error) {
    //         console.log('Unknown Error')
    //         return
    //       }
    //       this.tokenBalance = result
    //       console.log('Balance:', result)
    //     })
    //   },
    //   getTokenInfo () {
    //     console.log('Getting TotalSupply:', this.contractAdd)
    //     var query = new Web3(this.address)
    //     var contract = new query.eth.Contract(this.ERC20ABI, this.contractAdd)
    //     contract.methods.totalSupply().call((error, result) => {
    //       if (error) {
    //         console.log('Unknown Error')
    //         return
    //       }
    //       this.totalSupply = result
    //       console.log('Total Supply:', result)
    //     })
    //     contract.methods.name().call((error, result) => {
    //       if (error) {
    //         console.log('Unknown Error')
    //         return
    //       }
    //       this.tokenName = result
    //       console.log('TokenName:', result)
    //     })
    //     contract.methods.symbol().call((error, result) => {
    //       if (error) {
    //         console.log('Unknown Error')
    //         return
    //       }
    //       this.tokenSymbol = result
    //       console.log('TokenSymbol:', result)
    //     })
    //   }

  },
  mounted: function mounted() {
    console.log('Mounted Check Events');
    this.loadUserEvents();
  },

  beforeCreate: function beforeCreate() {
    // firebase.auth().onAuthStateChanged((response) => {
    //   if (response) {
    //     this.user = response
    //       // LOAD EXISING ACCOUNTS HERE
    //     this.status = true
    //     console.log('Got a User')
    //     console.log('Userdata', this.user)
    //     // load user info !!!!!!!!!!!!!!!!!!!!!!
    //     // this.loadUserPortfolio()
    //     this.walletComment = 'Add Wallet Address'
    //     this.happyButton = 'Send'
    //     this.loadUserSettings()
    //     this.loadUserEvents()
    //   } else {
    //     console.log('No User')
    //     this.user = ''
    //     this.status = false
    //   }
    // })
  }
});

/***/ }),

/***/ "A8Ip":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_btr_about_vue__ = __webpack_require__("E5zx");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7752f3e3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_btr_about_vue__ = __webpack_require__("NAzy");
function injectStyle (ssrContext) {
  __webpack_require__("FNHI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7752f3e3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_btr_about_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7752f3e3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_btr_about_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "B0eO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_btr_first_vue__ = __webpack_require__("qB1E");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b1c0c1c6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_btr_first_vue__ = __webpack_require__("XIoM");
function injectStyle (ssrContext) {
  __webpack_require__("unug")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b1c0c1c6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_btr_first_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b1c0c1c6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_btr_first_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BEV9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"size":"md","hide-footer":""},model:{value:(_vm.logInModal),callback:function ($$v) {_vm.logInModal=$$v},expression:"logInModal"}},[_c('div',{attrs:{"slot":"modal-header"},slot:"modal-header"},[_c('svg',{attrs:{"version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","preserveAspectRatio":"xMidYMid meet","viewBox":"0 350 500 250","height":"50"}},[_c('defs',[_c('path',{attrs:{"d":"M150 448.33L150 598.33L0 598.33L0 348.33L50 348.33L50 448.33L150 448.33ZM275 498.33L275 598.33L225 598.33L225 498.33L175 498.33L175 448.33L325 448.33L325 498.33L275 498.33ZM500 498.33L400 498.33L400 598.33L350 598.33L350 448.33L500 448.33L500 498.33ZM50 548.33L100 548.33L100 498.33L50 498.33L50 548.33Z","id":"logo"}})]),_vm._v(" "),_c('g',[_c('use',{staticClass:"logosvg",attrs:{"xlink:href":"#logo"}})])])]),_vm._v(" "),_c('b-form-input',{attrs:{"id":"email","placeholder":"Enter Email","state":_vm.emailValid,"type":"email"},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-form-input',{attrs:{"id":"password","placeholder":"Enter Password","state":_vm.checkPassword,"type":"password"},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}}),_vm._v(" "),_c('br'),_vm._v("  \n  "+_vm._s(_vm.errorText)+"   \n  "),_c('div',{staticClass:"text-center"},[_c('b-btn',{staticClass:"mt-3",attrs:{"disabled":!_vm.formValid,"variant":"outline-warning","size":"lg"},on:{"click":_vm.emailSignIn}},[_vm._v("Log In")]),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"outline-danger","size":"lg"},on:{"click":function($event){_vm.$emit('close')}}},[_vm._v("Cancel")]),_vm._v(" "),_c('br'),_vm._v("    \n        By continuing you Accept our "),_c('router-link',{attrs:{"to":"terms","target":"_blank"}},[_vm._v("Terms of use ")])],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('b-btn',{on:{"click":_vm.googleSignIn}},[_c('font-awesome-icon',{staticClass:"socialicon",attrs:{"icon":['fab', 'google'],"size":"1x"}}),_vm._v("  Continue with Google")],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BTPz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bb5b4f1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_btr_happyterms_vue__ = __webpack_require__("FTce");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bb5b4f1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_btr_happyterms_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CEK9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_btr_happyoffer_vue__ = __webpack_require__("9wwn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e8f5b06_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_btr_happyoffer_vue__ = __webpack_require__("1tfX");
function injectStyle (ssrContext) {
  __webpack_require__("SfR5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1e8f5b06"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_btr_happyoffer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e8f5b06_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_btr_happyoffer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "D4uH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Icon_vue__ = __webpack_require__("dXrS");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5e22f0aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Icon_vue__ = __webpack_require__("O0jz");
function injectStyle (ssrContext) {
  __webpack_require__("c0Rt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Icon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5e22f0aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Icon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "E5zx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import Chart from 'chart.js'

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {},
  data: function data() {
    return {
      status: 'updated'
    };
  },
  computed: {},
  created: function created() {},

  methods: {
    closeBox: function closeBox() {
      console.log('emit event to close about box', true);
      this.$emit('close-about', false);
    }
  },
  mounted: function mounted() {}
});

/***/ }),

/***/ "EPoy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_signUp_vue__ = __webpack_require__("Q1H6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_035d142c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_signUp_vue__ = __webpack_require__("0b5j");
function injectStyle (ssrContext) {
  __webpack_require__("2g8o")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-035d142c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_signUp_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_035d142c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_signUp_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FNHI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FTce":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('b-row',{staticClass:"justify-content-md-center"},[_c('b-col',{attrs:{"cols":"8"}},[_c('h1',[_vm._v("Happiness - Terms and Conditions ")]),_vm._v(" "),_c('h4',[_vm._v("Happiness (HAPPY) ERC20 Token Giveaway")]),_vm._v("\n\n          BTR Works reserves the right to alter or cancel any promotion at any\n          time. HAPPY Tokens will be distributed while supplies last. \n          The quantity of HAPPY Tokens given to each site user may be \n          periodically adjusted at the discretion of BTR Works. \n          HAPPY Tokens are assumed by BTR Works to have no market value \n          whatsoever at the time of issue. HAPPY Tokens are for \n          promotional / marketing use only and are not redeemable for any \n          Zero Agenda Inc or BTR Works goods or services. \n          BTR Works neither expects nor warrants any future market value \n          for HAPPY Tokens. BTR Works strongly discourages the use of \n          HAPPY Tokens for financial transactions or speculative investments \n          of any kind. By accepting HAPPY Tokens from BTR Works, \n          you agree that you will not:\n      "),_c('ul',[_c('li',[_vm._v(" use HAPPY tokens in any way which is unlawful, illegal, fraudulent or harmful, or in connection with any unlawful, illegal, fraudulent or harmful purpose or activity;")]),_vm._v(" "),_c('li',[_vm._v(" operate any script, program, “bot”, or other automation with the purpose or intent of accumulating HAPPY Tokens from BTR Works;")]),_vm._v(" "),_c('li',[_vm._v(" misrepresent the value of HAPPY Tokens;")]),_vm._v(" "),_c('li',[_vm._v(" impersonate or otherwise claim affiliation with BTR Works for the purpose of buying, selling or distributing HAPPY Tokens.")])]),_vm._v("\n          BTR Works makes no representations or warranties in relation to HAPPY Tokens. Distribution of HAPPY Tokens by BTR Works does not constitute advice of any kind. If you require advice in relation to any legal or financial matter you should consult an appropriate professional. \n\n          BTR Works assumes no liability in relation to the distribution or use of HAPPY Tokens.\n\n      ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GfHa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "H4dm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c353312_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_btr_disclaim_vue__ = __webpack_require__("1j2Z");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c353312_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_btr_disclaim_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HyLO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Hz6k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('canvas',{attrs:{"id":_vm.title,"width":"80%","height":"80%"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Id91":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IvaP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{staticClass:"mt-2",attrs:{"cols":"12","sm":"6","md":"4","lg":"3","xl":"2"}},[_c('b-card',{attrs:{"draggable":""}},[_c('b-form-row',{attrs:{"slot":"header","id":"head"},slot:"header"},[_c('b-col',[_vm._v(_vm._s(_vm.asset.name)+" ("+_vm._s(_vm.asset.symbol)+") \n        "),_c('b-btn',{staticClass:"close",attrs:{"hidden":this.base(),"type":"button"},on:{"click":_vm.closeTicker}},[_vm._v("\n      ╳")])],1)],1),_vm._v(" "),_c('b-form-row',{},[_c('b-col',{staticClass:"text-center",attrs:{"cols":"6","sm":"12","md":"12","lg":"12"}},[_c('div',{attrs:{"id":"assetPriceBase"}},[_vm._v("$"+_vm._s((_vm.asset.data.price * _vm.baseCurrency()).toFixed(2)))]),_vm._v(" "),_c('div',{attrs:{"id":"assetPercentBase"}},[_vm._v(_vm._s(_vm.totalPercentage())+"%")]),_vm._v(" "),_c('div',{attrs:{"id":"assetPrice"}},[_vm._v(_vm._s(_vm.asset.data.price)),_c('span',{staticClass:"resolveToSymbol"},[_vm._v(" ("+_vm._s(_vm.asset.resolveTo)+")")])]),_vm._v(" "),_c('div',{attrs:{"id":"assetPercent"}},[_vm._v(_vm._s((_vm.asset.data.percent).toFixed(3))+"%")])]),_vm._v(" "),_c('b-col',{staticClass:"text-center totals",attrs:{"cols":"6","sm":"12","md":"12","lg":"12"}},[_c('div',{attrs:{"id":"assetTotalBase"}},[_vm._v("$"+_vm._s((_vm.asset.total * this.baseCurr.data.price).toFixed(2)))]),_vm._v(" "),_c('div',{attrs:{"id":"assetTotal"}},[_vm._v(_vm._s((_vm.asset.total).toFixed(7))),_c('span',{staticClass:"resolveToSymbol"},[_vm._v(" (BTC)")])])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IwHf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"justify-content-md-center"},[_c('b-col',{attrs:{"cols":"8"}},[_c('h1',[_vm._v("Add Coin")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('b-input-group',{attrs:{"prepend":"Name"}},[_c('b-form-input',{model:{value:(_vm.asset.name),callback:function ($$v) {_vm.$set(_vm.asset, "name", $$v)},expression:"asset.name"}},[_vm._v("Name:")])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-input-group',{attrs:{"prepend":"Symbol"}},[_c('b-form-input',{model:{value:(_vm.asset.symbol),callback:function ($$v) {_vm.$set(_vm.asset, "symbol", $$v)},expression:"asset.symbol"}},[_vm._v("Symbol:")])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-input-group',{attrs:{"prepend":"Exchange"}},[_c('b-form-input',{model:{value:(_vm.asset.exchange),callback:function ($$v) {_vm.$set(_vm.asset, "exchange", $$v)},expression:"asset.exchange"}},[_vm._v("Exchange:")])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-input-group',{attrs:{"prepend":"Resolve"}},[_c('b-form-input',{model:{value:(_vm.asset.resolveTo),callback:function ($$v) {_vm.$set(_vm.asset, "resolveTo", $$v)},expression:"asset.resolveTo"}},[_vm._v("Resolve To (base):")])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-input-group',{attrs:{"prepend":"Link"}},[_c('b-form-input',{model:{value:(_vm.asset.link),callback:function ($$v) {_vm.$set(_vm.asset, "link", $$v)},expression:"asset.link"}},[_vm._v("Link:")])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-input-group',{attrs:{"prepend":"Note"}},[_c('b-form-input',{model:{value:(_vm.asset.note),callback:function ($$v) {_vm.$set(_vm.asset, "note", $$v)},expression:"asset.note"}})],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-btn',{staticClass:"text-center",on:{"click":_vm.pushCoin}},[_vm._v("Add Coin")])],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"12"}},[_c('br'),_vm._v(" "),_c('b-table',{attrs:{"striped":"","hover":"","outlined":"","fields":_vm.coinFields,"items":_vm.coinList}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LEDJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js__ = __webpack_require__("WaEV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_chart_js__);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    update: '',
    title: '',
    labels: {
      default: {}
    },
    portfolio: {
      default: {}
    },
    baseCurr: {
      default: {}
    }
  },
  data: function data() {
    return {
      chartdata: {
        type: 'doughnut',
        data: {
          labels: this.labels,
          datasets: [{
            data: this.portfolio,
            backgroundColor: ['rgba(255, 99, 132, 0.2)', 'rgba(54, 162, 235, 0.2)', 'rgba(255, 159, 64, 0.2)', 'rgba(0, 123, 0, 0.2)', 'rgba(200, 123, 200, 0.2)', 'rgba(0, 180, 180, 0.2)', 'rgba(0, 74, 74, 0.2)', 'rgba(220, 200, 74, 0.2)']
          }]
        },
        options: {
          responsive: true,
          legend: {
            display: false
          },
          tooltips: {
            callbacks: {
              label: function label(tooltipItem, data) {
                // var label = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index] || ''
                // label += tooltipItem.data + 'BTC'

                var label = data.labels[tooltipItem.index] || '';

                // var label = this.labels[tooltipItem.index]
                console.log('tt', tooltipItem.index);
                console.log(data);
                return ' ' + label;
              }
            },
            bodyFontSize: 25,
            bodySpacing: 4,
            backgroundColor: 'rgba(73,73,73,0.5)',
            xPadding: 12,
            yPadding: 12
          }
        }
      }
    };
  },

  watch: {
    update: function update() {
      if (this.update) {
        this.updateChart();
        this.$emit('updated', this.update);
      } else {
        console.log('no update');
      }
    }
  },
  methods: {
    updateChart: function updateChart() {
      console.log('updateing with:', this.chartdata);
      this.chartdata.data.labels = this.labels;
      this.chartdata.data.datasets[0].data = this.portfolio;
      this.myChart.update(this.chartdata);
    }
  },
  mounted: function mounted() {
    console.log(this.chartdata);
    var ctx = document.getElementById(this.title);
    this.myChart = new __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a(ctx, this.chartdata);
    console.log('initial:', this.chartdata.data);
  }
});
/* eslint-enable  */

/***/ }),

/***/ "LdjY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__("kxiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SignIn',
  props: { logInModal: false },
  data: function data() {
    return {
      email: '',
      password: '',
      confirmPassword: '',
      user: undefined,
      errorText: ''
    };
  },
  mounted: function mounted() {},

  computed: {
    checkPassword: function checkPassword() {
      if (this.password.length > 5) {
        return true;
      } else if (this.password.length === 0) {
        return null;
      } else {
        return false;
      }
    },
    emailValid: function emailValid() {
      if (this.email) {
        var re = /\S+@\S+\.\S+/; // may need to dig a bit deeper into correct RE for this
        return re.test(this.email);
      } else {
        return null;
      }
    },
    formValid: function formValid() {
      return this.emailValid && this.checkPassword;
    }
  },
  methods: {
    googleSignIn: function googleSignIn() {
      var _this = this;

      this.hideModal();
      var provider = new __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth.GoogleAuthProvider();
      __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth().signInWithPopup(provider).then(function (result) {
        _this.$parent.user = result.user;
        _this.$parent.status = true;
      }).catch(function (error) {
        return console.log(error);
      });
    },
    emailSignIn: function emailSignIn() {
      var _this2 = this;

      // this.hideModal()
      __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth().signInWithEmailAndPassword(this.email, this.password).then(function (user) {
        _this2.hideModal();
        console.log('setLoading');
        console.log('Created User', user);
      }).catch(function (error) {
        console.log(error.message);
        _this2.errorText = error.message;
      });
    },
    hideModal: function hideModal() {
      this.$emit('close');
    },
    showModal: function showModal() {
      this.$refs.signUpModalRef.show();
    }
  }
});

/***/ }),

/***/ "LsxN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_166e4b96_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("PI1g");
function injectStyle (ssrContext) {
  __webpack_require__("lbH/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-166e4b96"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_166e4b96_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NAzy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',{staticClass:"justify-content-md-center"},[_c('b-col',{attrs:{"cols":"8"}},[_c('h1',[_vm._v("About Us ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',[_vm._v("\n                  Welcome to bTr Works. We created this tool with one goal in mind:\n                  Simple, easy and clear tracking of Bitcoin, altcoins, tokens and all major cryptocurrencies. \n                  No hassle - no hype! The tool is free for you to use and we hope that you will find\n                  it useful in making solid trading decisions. Please let us know what you think via any of our \n                  social channels. Your comments, suggestions and requests are welcome here. \n                  We’re committed to continuing development of this tool and look forward to hearing about your \n                  experience using it.\n                ")]),_vm._v(" "),_c('p',[_vm._v("Thanks,")]),_vm._v(" "),_c('p',[_vm._v(" -Nick and Rich- ")])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__ = __webpack_require__("e6fC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_dist_css_bootstrap_min_css__ = __webpack_require__("qb6w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_dist_css_bootstrap_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_bootstrap_dist_css_bootstrap_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__("9M+g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_chart_js__ = __webpack_require__("WaEV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__filters_date__ = __webpack_require__("5TPd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__filters_pretty__ = __webpack_require__("ozpK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_User_login__ = __webpack_require__("3rUv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_User_signUp__ = __webpack_require__("EPoy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_btr_ticker__ = __webpack_require__("vWPn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_btr_chart__ = __webpack_require__("ppJm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_btr_donut__ = __webpack_require__("wlUl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_btr_social__ = __webpack_require__("3eXR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_btr_happy__ = __webpack_require__("24tJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_splash_btr_first__ = __webpack_require__("B0eO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_splash_btr_splash__ = __webpack_require__("QyAV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_splash_btr_about__ = __webpack_require__("A8Ip");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_splash_btr_terms__ = __webpack_require__("rABr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_splash_btr_donate__ = __webpack_require__("Qstq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_splash_btr_addcoin__ = __webpack_require__("fJwl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_splash_btr_disclaim__ = __webpack_require__("H4dm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_splash_btr_privacy__ = __webpack_require__("iybR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_splash_btr_happyoffer__ = __webpack_require__("CEK9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_vue_select__ = __webpack_require__("T1ft");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__fortawesome_fontawesome_svg_core__ = __webpack_require__("C/JF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__fortawesome_free_brands_svg_icons__ = __webpack_require__("DfMW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__fortawesome_vue_fontawesome__ = __webpack_require__("U0v6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__fortawesome_vue_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__fortawesome_vue_fontawesome__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

































__WEBPACK_IMPORTED_MODULE_28__fortawesome_fontawesome_svg_core__["library"].add(__WEBPACK_IMPORTED_MODULE_29__fortawesome_free_brands_svg_icons__["a" /* fab */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('btr-login', __WEBPACK_IMPORTED_MODULE_11__components_User_login__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('btr-signup', __WEBPACK_IMPORTED_MODULE_12__components_User_signUp__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('btr-happy', __WEBPACK_IMPORTED_MODULE_17__components_btr_happy__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('btr-happyoffer', __WEBPACK_IMPORTED_MODULE_26__components_splash_btr_happyoffer__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('btr-ticker', __WEBPACK_IMPORTED_MODULE_13__components_btr_ticker__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('btr-chart', __WEBPACK_IMPORTED_MODULE_14__components_btr_chart__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('btr-donut', __WEBPACK_IMPORTED_MODULE_15__components_btr_donut__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('v-select', __WEBPACK_IMPORTED_MODULE_27_vue_select___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('font-awesome-icon', __WEBPACK_IMPORTED_MODULE_30__fortawesome_vue_fontawesome__["FontAwesomeIcon"]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('btr-social', __WEBPACK_IMPORTED_MODULE_16__components_btr_social__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('btr-splash', __WEBPACK_IMPORTED_MODULE_19__components_splash_btr_splash__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('btr-addcoin', __WEBPACK_IMPORTED_MODULE_23__components_splash_btr_addcoin__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('btr-donate', __WEBPACK_IMPORTED_MODULE_22__components_splash_btr_donate__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('btr-terms', __WEBPACK_IMPORTED_MODULE_21__components_splash_btr_terms__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('btr-about', __WEBPACK_IMPORTED_MODULE_20__components_splash_btr_about__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('btr-first', __WEBPACK_IMPORTED_MODULE_18__components_splash_btr_first__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('btr-disclaim', __WEBPACK_IMPORTED_MODULE_24__components_splash_btr_disclaim__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('btr-privacy', __WEBPACK_IMPORTED_MODULE_25__components_splash_btr_privacy__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('pretty', __WEBPACK_IMPORTED_MODULE_10__filters_pretty__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('date', __WEBPACK_IMPORTED_MODULE_9__filters_date__["a" /* default */]);
/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  chart: __WEBPACK_IMPORTED_MODULE_7_chart_js___default.a,
  axios: __WEBPACK_IMPORTED_MODULE_8_axios___default.a,
  router: __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */],
  Vuex: __WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */] },
  created: function created() {}
});

/***/ }),

/***/ "O0jz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:_vm.klass,style:(_vm.style),attrs:{"version":"1.1","role":_vm.label ? 'img' : 'presentation',"aria-label":_vm.label,"x":_vm.x,"y":_vm.y,"width":_vm.width,"height":_vm.height,"viewBox":_vm.box}},[_vm._t("default",[(_vm.icon && _vm.icon.paths)?_vm._l((_vm.icon.paths),function(path,i){return _c('path',_vm._b({key:("path-" + i)},'path',path,false))}):_vm._e(),_vm._v(" "),(_vm.icon && _vm.icon.polygons)?_vm._l((_vm.icon.polygons),function(polygon,i){return _c('polygon',_vm._b({key:("polygon-" + i)},'polygon',polygon,false))}):_vm._e(),_vm._v(" "),(_vm.icon && _vm.icon.raw)?[_c('g',{domProps:{"innerHTML":_vm._s(_vm.raw)}})]:_vm._e()])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "O2cR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('b-row',{staticClass:"justify-content-md-center"},[_c('b-col',{attrs:{"cols":"8"}},[_c('h1',[_vm._v("Terms and Conditions ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h5',[_vm._v("Credit ")]),_vm._v(" "),_c('p',[_vm._v("This document was created using a Contractology template available at http://www.contractology.com.")]),_vm._v(" "),_c('h5',[_vm._v("Introduction")]),_vm._v(" "),_c('p',[_vm._v("These terms and conditions govern your use of this website; by using this website, you accept these terms and conditions in full. If you disagree with these terms and conditions or any part of these terms and conditions, you must not use this website.\n        ")]),_vm._v(" "),_c('p',[_vm._v("You must be at least 18 years of age to use this website. By using this website and by agreeing to these terms and conditions you warrant and represent that you are at least 18 years of age.\n        ")]),_vm._v(" "),_c('p',[_vm._v("This website uses cookies. By using this website and agreeing to these terms and conditions, you consent to our use of cookies in accordance with the terms of BTR Works' privacy policy.\n        ")]),_vm._v(" "),_c('h5',[_vm._v("License to use website")]),_vm._v(" "),_c('p',[_vm._v("Unless otherwise stated, BTR Works and/or its licensors own the intellectual property rights in the website and material on the website. Subject to the license below, all these intellectual property rights are reserved.\n        ")]),_vm._v(" "),_c('p',[_vm._v("You may view, download for caching purposes only, and print pages from the website for your own personal use, subject to the restrictions set out below and elsewhere in these terms and conditions.  \n        ")]),_vm._v(" "),_c('p',[_vm._v("You must not:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("republish material from this website (including republication on another website);")]),_vm._v(" "),_c('li',[_vm._v("sell, rent or sub-license material from the website;")]),_vm._v(" "),_c('li',[_vm._v("show any material from the website in public;")]),_vm._v(" "),_c('li',[_vm._v("reproduce, duplicate, copy or otherwise exploit material on this website for a commercial purpose;")]),_vm._v(" "),_c('li',[_vm._v("edit or otherwise modify any material on the website; or")]),_vm._v(" "),_c('li',[_vm._v("redistribute material from this website, except for content specifically and expressly made available for redistribution.")])]),_vm._v(" "),_c('h5',[_vm._v("Acceptable use")]),_vm._v(" "),_c('p',[_vm._v("You must not use this website in any way that causes, or may cause, damage to the website or impairment of the availability or accessibility of the website; or in any way which is unlawful, illegal, fraudulent or harmful, or in connection with any unlawful, illegal, fraudulent or harmful purpose or activity.\n        ")]),_vm._v(" "),_c('p',[_vm._v("You must not use this website to copy, store, host, transmit, send, use, publish or distribute any material which consists of (or is linked to) any spyware, computer virus, Trojan horse, worm, keystroke logger, rootkit or other malicious computer software.\n        ")]),_vm._v(" "),_c('p',[_vm._v("You must not conduct any systematic or automated data collection activities (including without limitation scraping, data mining, data extraction and data harvesting) on or in relation to this website without BTR Works’ express written consent.\n        ")]),_vm._v(" "),_c('p',[_vm._v("You must not use this website to transmit or send unsolicited commercial communications.\n        ")]),_vm._v(" "),_c('p',[_vm._v("You must not use this website for any purposes related to marketing without BTR Works’ express written consent.\n        ")]),_vm._v(" "),_c('h5',[_vm._v("Restricted access")]),_vm._v(" "),_c('p',[_vm._v("BTR Works reserves the right to restrict access to other areas of this website, or indeed this entire website, at BTR Works’ discretion.\n        ")]),_vm._v(" "),_c('p',[_vm._v("If BTR Works provides you with a user ID and password to enable you to access restricted areas of this website or other content or services, you must ensure that the user ID and password are kept confidential.\n        ")]),_vm._v(" "),_c('p',[_vm._v("BTR Works may disable your user ID and password in BTR Works’ sole discretion without notice or explanation.\n        ")]),_vm._v(" "),_c('h5',[_vm._v("User content")]),_vm._v(" "),_c('p',[_vm._v("In these terms and conditions, “your user content” means material (including without limitation text, images, audio material, video material and audio-visual material) that you submit to this website, for whatever purpose.\n        ")]),_vm._v(" "),_c('p',[_vm._v("You grant to BTR Works a worldwide, irrevocable, non-exclusive, royalty-free license to use, reproduce, adapt, publish, translate and distribute your user content in any existing or future media.  You also grant to BTR Works the right to sub-license these rights, and the right to bring an action for infringement of these rights.\n        ")]),_vm._v(" "),_c('p',[_vm._v("Your user content must not be illegal or unlawful, must not infringe any third party's legal rights, and must not be capable of giving rise to legal action whether against you or BTR Works or a third party (in each case under any applicable law).\n        ")]),_vm._v(" "),_c('p',[_vm._v("You must not submit any user content to the website that is or has ever been the subject of any threatened or actual legal proceedings or other similar complaint.\n        ")]),_vm._v(" "),_c('p',[_vm._v("BTR Works reserves the right to edit or remove any material submitted to this website, or stored on BTR Works’ servers, or hosted or published upon this website.\n        ")]),_vm._v(" "),_c('p',[_vm._v("Notwithstanding BTR Works’ rights under these terms and conditions in relation to user content, BTR Works does not undertake to monitor the submission of such content to, or the publication of such content on, this website.\n        ")]),_vm._v(" "),_c('h5',[_vm._v("No warranties")]),_vm._v(" "),_c('p',[_vm._v("This website is provided “as is” without any representations or warranties, express or implied. BTR Works makes no representations or warranties in relation to this website or the information and materials provided on this website.\n        ")]),_vm._v(" "),_c('p',[_vm._v("Without prejudice to the generality of the foregoing paragraph, BTR Works does not warrant that:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("this website will be constantly available, or available at all; or")]),_vm._v(" "),_c('li',[_vm._v("the information on this website is complete, true, accurate or non-misleading.")])]),_vm._v(" "),_c('p',[_vm._v("Nothing on this website constitutes, or is meant to constitute, advice of any kind. If you require advice in relation to any legal or financial matter you should consult an appropriate professional.\n        ")]),_vm._v(" "),_c('h5',[_vm._v("Limitations of liability")]),_vm._v(" "),_c('p',[_vm._v("BTR Works will not be liable to you (whether under the law of contract, the law of torts or otherwise) in relation to the contents of, or use of, or otherwise in connection with, this website:\n        ")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("to the extent that the website is provided free-of-charge, for any direct loss;")]),_vm._v(" "),_c('li',[_vm._v("for any indirect, special or consequential loss; or")]),_vm._v(" "),_c('li',[_vm._v("for any business losses, loss of revenue, income, profits or anticipated savings, loss of contracts or business relationships, loss of reputation or goodwill, or loss or corruption of information or data.")])]),_vm._v(" "),_c('p',[_vm._v("These limitations of liability apply even if BTR Works has been expressly advised of the potential loss.\n        ")]),_vm._v(" "),_c('h5',[_vm._v("Exceptions")]),_vm._v(" "),_c('p',[_vm._v("Nothing in this website disclaimer will exclude or limit any warranty implied by law that it would be unlawful to exclude or limit; and nothing in this website disclaimer will exclude or limit BTR Works’ liability in respect of any:\n        ")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("death or personal injury caused by BTR Works’ negligence;")]),_vm._v(" "),_c('li',[_vm._v("fraud or fraudulent misrepresentation on the part of BTR Works; or")]),_vm._v(" "),_c('li',[_vm._v("matter which it would be illegal or unlawful for BTR Works to exclude or limit, or to attempt or purport to exclude or limit, its liability.")])]),_vm._v(" "),_c('h5',[_vm._v("Reasonableness")]),_vm._v(" "),_c('p',[_vm._v("\n        By using this website, you agree that the exclusions and limitations of liability set out in this website disclaimer are reasonable.  \n        If you do not think they are reasonable, you must not use this website.\n        ")]),_vm._v(" "),_c('h5',[_vm._v("Other parties")]),_vm._v(" "),_c('p',[_vm._v("You accept that, as a limited liability entity, BTR Works has an interest in limiting the personal liability of its officers and employees.  You agree that you will not bring any claim personally against BTR Works’ officers or employees in respect of any losses you suffer in connection with the website.\n        ")]),_vm._v(" "),_c('p',[_vm._v("Without prejudice to the foregoing paragraph, you agree that the limitations of warranties and liability set out in this website disclaimer will protect BTR Works’ officers, employees, agents, subsidiaries, successors, assigns and sub-contractors as well as BTR Works.\n        ")]),_vm._v(" "),_c('h5',[_vm._v("Unenforceable provisions")]),_vm._v(" "),_c('p',[_vm._v("If any provision of this website disclaimer is, or is found to be, unenforceable under applicable law, that will not affect the enforceability of the other provisions of this website disclaimer.\n        ")]),_vm._v(" "),_c('h5',[_vm._v("Indemnity")]),_vm._v(" "),_c('p',[_vm._v("You hereby indemnify BTR Works and undertake to keep BTR Works indemnified against any losses, damages, costs, liabilities and expenses (including without limitation legal expenses and any amounts paid by BTR Works to a third party in settlement of a claim or dispute on the advice of BTR Works’ legal advisers) incurred or suffered by BTR Works arising out of any breach by you of any provision of these terms and conditions, or arising out of any claim that you have breached any provision of these terms and conditions.\n        ")]),_vm._v(" "),_c('h5',[_vm._v("Breaches of these terms and conditions ")]),_vm._v(" "),_c('p',[_vm._v("Without prejudice to BTR Works’ other rights under these terms and conditions, if you breach these terms and conditions in any way, BTR Works may take such action as BTR Works deems appropriate to deal with the breach, including suspending your access to the website, prohibiting you from accessing the website, blocking computers using your IP address from accessing the website, contacting your internet service provider to request that they block your access to the website and/or bringing court proceedings against you.")]),_vm._v(" "),_c('h5',[_vm._v("Variation")]),_vm._v(" "),_c('p',[_vm._v("BTR Works may revise these terms and conditions from time-to-time.  Revised terms and conditions will apply to the use of this website from the date of the publication of the revised terms and conditions on this website.  Please check this page regularly to ensure you are familiar with the current version.\n        ")]),_vm._v(" "),_c('h5',[_vm._v("Assignment")]),_vm._v(" "),_c('p',[_vm._v("BTR Works may transfer, sub-contract or otherwise deal with BTR Works’ rights and/or obligations under these terms and conditions without notifying you or obtaining your consent.\n        ")]),_vm._v(" "),_c('p',[_vm._v("You may not transfer, sub-contract or otherwise deal with your rights and/or obligations under these terms and conditions.  \n        ")]),_vm._v(" "),_c('h5',[_vm._v("Severability")]),_vm._v(" "),_c('p',[_vm._v("If a provision of these terms and conditions is determined by any court or other competent authority to be unlawful and/or unenforceable, the other provisions will continue in effect.  If any unlawful and/or unenforceable provision would be lawful or enforceable if part of it were deleted, that part will be deemed to be deleted, and the rest of the provision will continue in effect.\n        ")]),_vm._v(" "),_c('h5',[_vm._v("Entire agreement")]),_vm._v(" "),_c('p',[_vm._v("These terms and conditions, together with the BTR Works Privacy Policy and BTR Works Disclaimer constitute the entire agreement between you and BTR Works in relation to your use of this website, and supersede all previous agreements in respect of your use of this website.\n        ")]),_vm._v(" "),_c('h5',[_vm._v("Law and jurisdiction")]),_vm._v(" "),_c('p',[_vm._v("These terms and conditions will be governed by and construed in accordance with governing Federal law as well as the law of the state of California, and any disputes relating to these terms and conditions will be subject to the exclusive jurisdiction of the courts of San Francisco, California.\n        ")]),_vm._v(" "),_c('h5',[_vm._v("Registrations and authorisations")]),_vm._v(" "),_c('h6',[_vm._v("The publisher, owner, and operator of BTR Works is Zero Agenda Inc\n        ")]),_vm._v(" "),_c('p',[_vm._v("Zero Agenda Inc is registered with the California Secretary of State Business Entities Register. You can find the online version of the register at https://businesssearch.sos.ca.gov/.")]),_vm._v(" "),_c('p',[_vm._v("Zero Agenda Inc’s registration number is C4105479.")])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PI1g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticStyle:{"padding":"0px"},attrs:{"fluid":"","bg-dark":""}},[_c('b-navbar',{attrs:{"type":"dark","variant":"secondary","sticky":"","id":"topbar","toggleable":""}},[_c('b-navbar-brand',{staticClass:"title",attrs:{"href":"#"}},[_c('svg',{attrs:{"version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","preserveAspectRatio":"xMidYMid meet","viewBox":"0 350 500 250","height":"50"}},[_c('defs',[_c('path',{attrs:{"d":"M150 448.33L150 598.33L0 598.33L0 348.33L50 348.33L50 448.33L150 448.33ZM275 498.33L275 598.33L225 598.33L225 498.33L175 498.33L175 448.33L325 448.33L325 498.33L275 498.33ZM500 498.33L400 498.33L400 598.33L350 598.33L350 448.33L500 448.33L500 498.33ZM50 548.33L100 548.33L100 498.33L50 498.33L50 548.33Z","id":"logo"}})]),_vm._v(" "),_c('g',[_c('use',{staticClass:"logosvg",attrs:{"xlink:href":"#logo"}})])])]),_vm._v(" "),_c('b-navbar-toggle',{attrs:{"target":"nav_dropdown_collapse"}}),_vm._v(" "),_c('b-collapse',{attrs:{"is-nav":"","id":"nav_dropdown_collapse"}},[_c('b-navbar-nav',{staticClass:"mx-auto"},[_c('b-nav-form',[_c('v-select',{staticStyle:{"fill":"white"},attrs:{"id":"coinInput","placeholder":"Choose Coin","label":"fullname","options":_vm.assetsList},on:{"input":function($event){_vm.addUserAsset()}},model:{value:(_vm.searchAsset),callback:function ($$v) {_vm.searchAsset=$$v},expression:"searchAsset"}})],1)],1),_vm._v(" "),_c('b-navbar-nav',{staticClass:"ml-auto"},[_c('b-btn',{staticClass:"my-2 my-0",attrs:{"hidden":_vm.status,"variant":"outline-warning"},on:{"click":_vm.login}},[_vm._v("Log In")]),_vm._v(" "),_c('b-btn',{staticClass:"my-2 mx-2",attrs:{"hidden":_vm.status,"variant":"warning"},on:{"click":_vm.signUp}},[_vm._v("Sign Up")]),_vm._v(" "),_c('b-nav-item-dropdown',{attrs:{"hidden":!_vm.status,"right":""}},[_c('template',{slot:"button-content"},[(_vm.status)?_c('em',[_vm._v(_vm._s(_vm.user.displayName || _vm.user.email))]):_vm._e()]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"/"}},[_vm._v("Profile")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":_vm.loadUserData}},[_vm._v("Load")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":_vm.saveUserData}},[_vm._v("Save")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":_vm.signOut}},[_vm._v("Signout")])],2)],1)],1)],1),_vm._v(" "),_c('main',[_c('b-container',{attrs:{"fluid":""}},[_c('router-view'),_vm._v(" "),(_vm.signUpModal)?_c('btr-signup',{attrs:{"signUpModal":_vm.signUpModal},on:{"close":function($event){_vm.signUpModal=false}}}):_vm._e(),_vm._v(" "),(_vm.logInModal)?_c('btr-login',{attrs:{"logInModal":_vm.logInModal},on:{"close":function($event){_vm.logInModal=false}}}):_vm._e(),_vm._v(" "),_c('b-form-row',[_c('b-col',{attrs:{"xs":"12","sm":"6","md":"6","lg":"8","xl":"9"}},[_c('b-form-row',{},[(_vm.settings.splashBox)?_c('b-col',{staticClass:"mt-2",attrs:{"lg":"12"}},[_c('btr-splash',{attrs:{"user":_vm.user,"content":_vm.settings.splashContent},on:{"close-splash":function($event){_vm.openSplash($event)}}})],1):_vm._e(),_vm._v(" "),_c('btr-happy',{attrs:{"wallet":_vm.walletList[0].address}}),_vm._v(" "),_vm._l((_vm.userAssets),function(asset,index){return _c('btr-ticker',{key:index,attrs:{"index":index,"asset":asset,"baseCurr":_vm.baseCurr},on:{"close-ticker":function($event){_vm.removeUserAsset($event)}}})})],2)],1),_vm._v(" "),_c('b-col',{staticClass:"my-2",attrs:{"xs":"12","sm":"6","md":"6","lg":"4","xl":"3"}},[_c('b-card',{attrs:{"no-body":""}},[_c('b-card-header',[_vm._v("\n              Portfolio\n            ")]),_vm._v(" "),_c('b-card-body',[_c('btr-donut',{attrs:{"title":"donut","update":_vm.update,"portfolio":_vm.portfolio,"labels":_vm.labels,"baseCurr":_vm.baseCurr},on:{"updated":function($event){_vm.changeUpdateState($event)}}}),_vm._v(" "),_c('br'),_vm._v(" "),_vm._l((_vm.userAssets),function(asset,index){return _c('div',{key:index},[_c('b-input-group',{staticClass:"mb-2",attrs:{"size":"sm"}},[_c('b-input-group-prepend',[_c('b-btn',{staticStyle:{"border":"none"},style:({'background-color': _vm.settings.colorlist[index]}),attrs:{"readonly":""}}),_vm._v(" "),_c('b-btn',{staticClass:"portfolioAssetName"},[_vm._v(_vm._s(asset.name))])],1),_vm._v(" "),_c('b-form-input',{staticClass:"portfolioAssetAmount",on:{"input":function($event){_vm.updateChart()}},model:{value:(asset.amount),callback:function ($$v) {_vm.$set(asset, "amount", $$v)},expression:"asset.amount"}}),_vm._v(" "),_c('b-input-group-append',[_c('b-input-group-text',{staticClass:"portfolioAssetSymbol"},[_vm._v("\n                      "+_vm._s(asset.symbol)+"\n                    ")])],1)],1)],1)})],2),_vm._v(" "),_c('b-card-footer',{staticClass:"text-center"},[_c('h5',[_vm._v(" $"+_vm._s((_vm.portfolioTotal()*_vm.baseCurr.data.price).toFixed(2))+" ")]),_vm._v(" "),_c('h6',{attrs:{"slot":"footer"},slot:"footer"},[_vm._v(" "+_vm._s(_vm.portfolioTotal().toFixed(6))),_c('small',[_vm._v("(BTC)")])])])],1)],1)],1)],1)],1),_vm._v(" "),_c('footer',[_c('b-nav',{staticClass:"footer"},[_c('span',{staticClass:"footerbrand"},[_vm._v("\n          ©  \n          "),_c('svg',{attrs:{"version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","preserveAspectRatio":"xMidYMid meet","viewBox":"0 350 500 250","height":"25"},on:{"click":function($event){_vm.alertBox = !_vm.alertBox}}},[_c('defs',[_c('path',{attrs:{"d":"M150 448.33L150 598.33L0 598.33L0 348.33L50 348.33L50 448.33L150 448.33ZM275 498.33L275 598.33L225 598.33L225 498.33L175 498.33L175 448.33L325 448.33L325 498.33L275 498.33ZM500 498.33L400 498.33L400 598.33L350 598.33L350 448.33L500 448.33L500 498.33ZM50 548.33L100 548.33L100 498.33L50 498.33L50 548.33Z","id":"footerlogo"}})]),_vm._v(" "),_c('g',[_c('use',{attrs:{"xlink:href":"#footerlogo"}})])])]),_vm._v(" "),_c('b-nav-item',{on:{"click":function($event){_vm.openSplash({splashContent:'about', splashBox:'true'})}}},[_vm._v("\n            About Us\n          ")]),_vm._v(" "),_c('b-nav-item',{on:{"click":function($event){_vm.openSplash({splashContent:'privacy', splashBox:'true'})}}},[_vm._v("\n            Privacy\n          ")]),_vm._v(" "),_c('b-nav-item',{on:{"click":function($event){_vm.openSplash({splashContent:'disclaim', splashBox:'true'})}}},[_vm._v("\n            Disclaimer\n          ")]),_vm._v(" "),_c('b-nav-item',{on:{"click":function($event){_vm.openSplash({splashContent:'terms', splashBox:'true'})}}},[_vm._v("\n            Terms\n          ")]),_vm._v(" "),_c('b-nav-item',{on:{"click":function($event){_vm.openSplash({splashContent:'donate', splashBox:'true'})}}},[_vm._v("\n            Donate\n          ")]),_vm._v(" "),_c('b-nav-item',{on:{"click":function($event){_vm.openSplash({splashContent:'happyoffer', splashBox:'true'})}}},[_vm._v("\n            Grab Happiness\n          ")]),_vm._v(" "),_c('btr-social'),_vm._v(" "),_c('b-nav-text',{staticClass:"ml-auto mr-2 mt-1",attrs:{"id":"footerUpdated"}},[_vm._v("\n          Last Update: "+_vm._s(_vm._f("date")(_vm.lastUpdated))+"\n          ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Q1H6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__("kxiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SignIn',
  props: { signUpModal: false },
  data: function data() {
    return {
      email: '',
      password: '',
      confirmPassword: '',
      user: undefined,
      errorText: ''
    };
  },
  mounted: function mounted() {},

  computed: {
    comparePasswords: function comparePasswords() {
      if (this.password) {
        return this.password !== this.confirmPassword ? 'Passwords do not match' : '';
      }
    },
    checkPassword: function checkPassword() {
      if (this.password.length > 5) {
        return true;
      } else if (this.password.length === 0) {
        return null;
      } else {
        return false;
      }
    },
    emailValid: function emailValid() {
      if (this.email) {
        var re = /\S+@\S+\.\S+/; // may need to dig a bit deeper into correct RE for this
        return re.test(this.email);
      } else {
        return null;
      }
    },
    formValid: function formValid() {
      return this.emailValid && this.checkPassword && this.password === this.confirmPassword;
    }
  },
  methods: {
    googleSignIn: function googleSignIn() {
      var _this = this;

      this.hideModal();
      var provider = new __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth.GoogleAuthProvider();
      __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth().signInWithPopup(provider).then(function (result) {
        _this.$parent.user = result.user;
        _this.$parent.status = true;
      }).catch(function (error) {
        return console.log(error);
      });
    },
    emailSignUp: function emailSignUp() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth().createUserWithEmailAndPassword(this.email, this.password).then(function (user) {
        _this2.hideModal();
        console.log('setLoading');
        console.log('Created User', user);
      }).catch(function (error) {
        console.log(error);
        _this2.errorText = error.message;
      });
    },
    hideModal: function hideModal() {
      this.$emit('close');
    },
    showModal: function showModal() {
      this.$refs.signUpModalRef.show();
    }
  }
});

/***/ }),

/***/ "QJh3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Qstq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_696a9a7e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_btr_donate_vue__ = __webpack_require__("8oj4");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_696a9a7e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_btr_donate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QyAV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_btr_splash_vue__ = __webpack_require__("52fR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5791f49e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_btr_splash_vue__ = __webpack_require__("p6Vp");
function injectStyle (ssrContext) {
  __webpack_require__("42Im")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5791f49e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_btr_splash_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5791f49e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_btr_splash_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SYlo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__("kxiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      update: false,
      coinFields: ['name', 'symbol', 'exchange', 'resolveTo', 'link', 'note'],
      coinList: [],
      asset: {
        name: '',
        symbol: '',
        exchange: 'Binance',
        resolveTo: 'BTC',
        note: 'None',
        link: 'None'
      }
    };
  },

  methods: {
    pushCoin: function pushCoin() {
      this.saveData('assets', this.asset);
    },
    saveData: function saveData(root, payload) {
      var _this = this;

      // save the user assets is good
      console.log('saving data', root, payload);
      __WEBPACK_IMPORTED_MODULE_0_firebase__["database"]().ref('/' + root + '/').push(payload).then(function (data) {
        console.log('Returned:', data);
        // ugly reset form data
        _this.asset.name = '';
        _this.asset.symbol = '';
        _this.asset.exchange = 'Binance';
        _this.asset.resolveTo = 'BTC';
        _this.asset.link = 'None';
        _this.asset.note = 'None';
      }).catch(function (error) {
        console.log(error);
      });
    }
  },
  created: function created() {
    var _this2 = this;

    var database = __WEBPACK_IMPORTED_MODULE_0_firebase__["database"]();

    database.ref('assets').on('child_added', function (data) {
      //   let obj = data.val()
      console.log('child Added', data.val());
      _this2.coinList.push(data.val());
    });
  }
});

/***/ }),

/***/ "SfR5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XIoM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-row',{staticClass:"justify-content-md-center"},[_c('b-col',{attrs:{"cols":"12"}},[_c('b-row',{staticClass:"text-center"},[_c('b-card-group',[_c('b-col',{attrs:{"sm":"12","md":"12","lg":"12","xl":"3"}},[_c('b-card',[_c('h5',[_vm._v("Set up in Seconds ")]),_vm._v(" "),_c('p',[_vm._v("Simply choose the coins you want to keep an eye on and rearrange them in the order you prefer.")])])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","md":"12","lg":"12","xl":"3"}},[_c('b-card',[_c('h5',[_vm._v(" Create a Portfolio ")]),_vm._v(" "),_c('p',[_vm._v("Add the amount of coins you already own and see how well your investments are doing at a glance.")])])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","md":"12","lg":"12","xl":"3"}},[_c('b-card',[_c('h5',[_vm._v("Watch your Crypto")]),_vm._v(" "),_c('p',[_vm._v("Load up your saved dashboard on your phone, tablet or computer. \n              Keep an eye on the markets wherever you go.")])])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","md":"12","lg":"12","xl":"3"}},[_c('b-card',[_c('b-btn',{attrs:{"variant":"outline-warning","size":"lg"},on:{"click":_vm.happyClick}},[_vm._v(" Grab Happiness ")]),_vm._v(" "),_c('br'),_vm._v("\n            Sign up for free "),_c('br'),_vm._v("\n            Add an Ethereum Wallet "),_c('br'),_vm._v("\n            Get some free Happiness\n          ")],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello__ = __webpack_require__("qSdX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_splash_btr_terms__ = __webpack_require__("rABr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_splash_btr_happyterms__ = __webpack_require__("BTPz");






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Hello',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Hello__["a" /* default */]
  }, {
    path: '/happyterms',
    name: 'happyterms',
    component: __WEBPACK_IMPORTED_MODULE_4__components_splash_btr_happyterms__["a" /* default */]
  }, {
    path: '/terms',
    name: 'terms',
    component: __WEBPACK_IMPORTED_MODULE_3__components_splash_btr_terms__["a" /* default */]
  }],
  mode: 'history'
}));

/***/ }),

/***/ "ZT1f":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aFrz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import Chart from 'chart.js'

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    index: '',
    asset: {
      default: {
        name: '',
        symbol: '',
        exchange: '',
        data: {
          symbol: '',
          price: 0,
          percent: 0
        },
        base: false,
        total: 0,
        amount: 0
      }
    },
    baseCurr: {
      default: {
        data: {
          symbol: 'BTC',
          price: 0,
          percent: 0
        },
        total: 0,
        amount: 0
      }
    }
  },
  data: function data() {
    return {
      status: 'updated',
      chartdata: {
        type: 'bar',
        data: {
          labels: ['lo', 'curr', 'hi'],
          datasets: [{
            data: [],
            backgroundColor: ['rgba(255, 99, 132, 0.2)', 'rgba(54, 162, 235, 0.2)', 'rgba(255, 159, 64, 0.2)']
          }]
        },
        options: {
          responsive: true,
          lineTension: 1,
          tooltips: {
            caretPadding: 4,
            titleFontSize: 20,
            bodyFontSize: 15,
            backgroundColor: 'rgba(73,73,73,0.5)',
            displayColors: false,
            mode: 'x',
            intersect: false
          },
          hover: {
            mode: 'index',
            intersect: false
          },
          legend: {
            display: false
          },
          scales: {
            yAxes: [{
              display: true,
              gridLines: { display: false },
              ticks: {
                beginAtZero: false,
                padding: 0
              }
            }],
            xAxes: [{
              display: true,
              gridLines: { display: false }
            }]
          }
        }
      }
    };
  },
  computed: {
    title: function title() {
      return this.asset.name;
    }
  },
  created: function created() {},

  methods: {
    baseCurrency: function baseCurrency() {
      if (this.baseCurr.data.price === this.asset.data.price) {
        return 1;
      } else {
        return this.baseCurr.data.price;
      }
    },
    base: function base() {
      if (this.baseCurr.data.price === this.asset.data.price) {
        return true;
      } else {
        return false;
      }
    },
    totalPercentage: function totalPercentage() {
      var assetDecimal = (100 + this.asset.data.percent) / 100;
      var baseDecimal = (100 + this.baseCurr.data.percent) / 100;
      if (this.baseCurr.data.price === this.asset.data.price) {
        return this.asset.data.percent.toFixed(3);
      } else {
        var answer = 100 * (assetDecimal * baseDecimal - 1);
        // answer = assetDecimal
        return answer.toFixed(3);
      }
    },
    closeTicker: function closeTicker() {
      console.log('emit event to close ticker', this.index);
      this.$emit('close-ticker', this.index);
    }
  },
  mounted: function mounted() {
    // const ctx = document.getElementById(this.title)
    // this.myChart = new Chart(ctx, this.chartdata)
    // console.log('initial:', this.chartdata.data)
  }
});

/***/ }),

/***/ "c0Rt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dXrS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var icons = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fa-icon',
  props: {
    name: {
      type: String,
      validator: function validator(val) {
        if (val && !(val in icons)) {
          console.warn('Invalid prop: prop "name" is referring to an unregistered icon "' + val + '".' + '\nPlease make sure you have imported this icon before using it.');
          return false;
        }
        return true;
      }
    },
    scale: [Number, String],
    spin: Boolean,
    inverse: Boolean,
    pulse: Boolean,
    flip: {
      validator: function validator(val) {
        return val === 'horizontal' || val === 'vertical';
      }
    },
    label: String
  },
  data: function data() {
    return {
      x: false,
      y: false,
      childrenWidth: 0,
      childrenHeight: 0,
      outerScale: 1
    };
  },

  computed: {
    normalizedScale: function normalizedScale() {
      var scale = this.scale;
      scale = typeof scale === 'undefined' ? 1 : Number(scale);
      if (isNaN(scale) || scale <= 0) {
        console.warn('Invalid prop: prop "scale" should be a number over 0.', this);
        return this.outerScale;
      }
      return scale * this.outerScale;
    },
    klass: function klass() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'fa-icon': true,
        'fa-spin': this.spin,
        'fa-flip-horizontal': this.flip === 'horizontal',
        'fa-flip-vertical': this.flip === 'vertical',
        'fa-inverse': this.inverse,
        'fa-pulse': this.pulse
      }, this.$options.name, true);
    },
    icon: function icon() {
      if (this.name) {
        return icons[this.name];
      }
      return null;
    },
    box: function box() {
      if (this.icon) {
        return '0 0 ' + this.icon.width + ' ' + this.icon.height;
      }
      return '0 0 ' + this.width + ' ' + this.height;
    },
    ratio: function ratio() {
      if (!this.icon) {
        return 1;
      }
      var _icon = this.icon,
          width = _icon.width,
          height = _icon.height;

      return Math.max(width, height) / 16;
    },
    width: function width() {
      return this.childrenWidth || this.icon && this.icon.width / this.ratio * this.normalizedScale || 0;
    },
    height: function height() {
      return this.childrenHeight || this.icon && this.icon.height / this.ratio * this.normalizedScale || 0;
    },
    style: function style() {
      if (this.normalizedScale === 1) {
        return false;
      }
      return {
        fontSize: this.normalizedScale + 'em'
      };
    },
    raw: function raw() {
      // generate unique id for each icon's SVG element with ID
      if (!this.icon || !this.icon.raw) {
        return null;
      }
      var raw = this.icon.raw;
      var ids = {};
      raw = raw.replace(/\s(?:xml:)?id=(["']?)([^"')\s]+)\1/g, function (match, quote, id) {
        var uniqueId = getId();
        ids[id] = uniqueId;
        return ' id="' + uniqueId + '"';
      });
      raw = raw.replace(/#(?:([^'")\s]+)|xpointer\(id\((['"]?)([^')]+)\2\)\))/g, function (match, rawId, _, pointerId) {
        var id = rawId || pointerId;
        if (!id || !ids[id]) {
          return match;
        }

        return '#' + ids[id];
      });

      return raw;
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (!this.name && this.$children.length === 0) {
      console.warn('Invalid prop: prop "name" is required.');
      return;
    }

    if (this.icon) {
      return;
    }

    var width = 0;
    var height = 0;
    this.$children.forEach(function (child) {
      child.outerScale = _this.normalizedScale;

      width = Math.max(width, child.width);
      height = Math.max(height, child.height);
    });
    this.childrenWidth = width;
    this.childrenHeight = height;
    this.$children.forEach(function (child) {
      child.x = (width - child.width) / 2;
      child.y = (height - child.height) / 2;
    });
  },
  register: function register(data) {
    for (var name in data) {
      var icon = data[name];

      if (!icon.paths) {
        icon.paths = [];
      }
      if (icon.d) {
        icon.paths.push({ d: icon.d });
      }

      if (!icon.polygons) {
        icon.polygons = [];
      }
      if (icon.points) {
        icon.polygons.push({ points: icon.points });
      }

      icons[name] = icon;
    }
  },

  icons: icons
});

var cursor = 0xd4937;
function getId() {
  return 'fa-' + (cursor++).toString(16);
}

/***/ }),

/***/ "dlQ+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{staticClass:"mt-2",attrs:{"cols":"12","sm":"6","md":"4","lg":"3","xl":"2"}},[_c('b-card',{attrs:{"draggable":""}},[_c('b-form-row',{attrs:{"slot":"header","id":"head"},slot:"header"},[_c('b-col',[_vm._v("Happi (HAPPY) ")])],1),_vm._v(" "),_c('b-form-row',{},[_c('b-col',{staticClass:"text-center",attrs:{"cols":"6","sm":"12","md":"12","lg":"12"}},[_c('svg',{staticClass:"my-2",attrs:{"aria-hidden":"true","preserveAspectRatio":"xMidYMid meet","width":"53","data-prefix":"fas","id":"smile","role":"img","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 496 512"}},[_c('path',{attrs:{"fill":"currentColor","d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 144c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.3-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm-160 0c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm80 280c-60.6 0-134.5-38.3-143.8-93.3-2-11.9 9.4-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"}})])]),_vm._v(" "),_c('b-col',{staticClass:"text-center totals",attrs:{"cols":"6","sm":"12","md":"12","lg":"12"}},[(!_vm.happy.amount>0)?_c('h6',[_vm._v("Get Some")]):_vm._e(),_vm._v(" "),(_vm.happy.amount>0)?_c('h4',{staticStyle:{"height":"32px"}},[_vm._v(_vm._s(_vm.happy.amount)+" (HAPPY)")]):_vm._e()])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "erN2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fJwl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_btr_addcoin_vue__ = __webpack_require__("SYlo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_549b80e2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_btr_addcoin_vue__ = __webpack_require__("IwHf");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_btr_addcoin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_549b80e2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_btr_addcoin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fiXB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"mt-2 mb-2",attrs:{"border-variant":"warning"}},[_c('h5',{attrs:{"slot":"header"},slot:"header"},[_c('ftr-focus')],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mt-2",attrs:{"md":"2","offset":"5"}},[_c('b-btn-group',{attrs:{"size":"sm","variant":"danger-outline"}},[_c('b-btn',{attrs:{"variant":"outline-secondary"},on:{"click":function($event){_vm.intervalChange('1m')}}},[_vm._v(" 1m ")]),_vm._v(" "),_c('b-btn',{attrs:{"variant":"outline-secondary"},on:{"click":function($event){_vm.intervalChange('1h')}}},[_vm._v(" 1h ")]),_vm._v(" "),_c('b-btn',{attrs:{"variant":"outline-secondary"},on:{"click":function($event){_vm.intervalChange('1d')}}},[_vm._v(" 1d ")]),_vm._v(" "),_c('b-btn',{attrs:{"variant":"outline-secondary"},on:{"click":function($event){_vm.intervalChange('1w')}}},[_vm._v(" 1w ")]),_vm._v(" "),_c('b-btn',{attrs:{"variant":"outline-secondary"},on:{"click":function($event){_vm.intervalChange('1y')}}},[_vm._v(" 1y ")])],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('canvas',{attrs:{"id":_vm.title,"width":"100vw","height":"20vh"}})])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iybR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8aea6f2e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_btr_privacy_vue__ = __webpack_require__("u6O7");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8aea6f2e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_btr_privacy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kXGl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js__ = __webpack_require__("WaEV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import ChartF  from '@/helpers/chart-financial.js'

/* harmony default export */ __webpack_exports__["a"] = ({
  watch: {
    symbolFocus: function symbolFocus() {
      this.updateChart();
    }
  },
  data: function data() {
    return {
      update: false,
      myChart: null,
      candles: [],
      candlesAmount: 101,
      candledate: [],
      open: [],
      closes: [],
      high: [],
      low: [],
      startDate: new Date(),
      interval: '1d',
      intervalOptions: [{ value: '1M', text: 'Month' }, { value: '1w', text: 'Week' }, { value: '3d', text: '3 Day' }, { value: '1d', text: 'Day' }, { value: '12h', text: '12 Hours' }, { value: '4h', text: '4 Hours' }, { value: '1h', text: 'Hour' }, { value: '30m', text: '30 Minutes' }, { value: '15m', text: '15 Minutes' }, { value: '5m', text: '5 Minutes' }, { value: '1m', text: '1 Minute' }],
      // start of chart data
      ChartData: {
        type: 'line',
        data: {
          // this is the bottom labals
          lineAtIndex: 2,
          labels: [],
          // this is the first dataset
          datasets: [{ // one line graph
            label: 'High',
            data: [],
            borderColor: ['rgba(0,200,0,0.5)'],
            backgroundColor: ['rgba(255,193,7,0.1)'],
            fill: 1,
            pointHoverRadius: 5,
            pointRadius: 0
          },
          //      2nd data set
          { // another line graph
            label: 'Low',
            data: [],
            borderColor: ['rgba(255,0,0,0.5)'],
            backgroundColor: ['rgba(73,73,73,0.2)'],
            fill: 'origin',
            type: 'line',
            pointHoverRadius: 5,
            pointRadius: 0
          }]
        },
        options: {
          responsive: true,
          lineTension: 1,
          tooltips: {
            caretPadding: 4,
            titleFontSize: 20,
            bodyFontSize: 15,
            bodyFont: 'Lato',
            backgroundColor: 'rgba(73,73,73,0.5)',
            displayColors: false,
            mode: 'x',
            intersect: false
          },
          hover: {
            mode: 'index',
            intersect: false
          },
          legend: {
            display: false
          },
          scales: {
            yAxes: [{
              display: false,
              gridLines: { display: false },
              ticks: {
                beginAtZero: false,
                padding: 25
              }
            }],
            xAxes: [{
              display: true,
              gridLines: { display: false },
              type: 'time',
              time: {
                unit: 'week',
                tooltipFormat: 'MMM D , YYYY',
                displayFormats: {
                  week: 'MMM D'
                }
              }
            }]
          },
          layout: {
            padding: {
              left: -50,
              right: 0,
              top: 0,
              bottom: 0
            }
          }
        }
        // end of chart data
      } };
  },

  computed: {
    symbolFocus: function symbolFocus() {
      return this.$store.getters.symbolFocus;
    },
    chartUpdate: function chartUpdate() {
      return this.$store.getters.chartUpdate;
    },
    title: function title() {
      return 'charty';
    }
  },
  methods: {
    /* eslint-disable no-unused-vars */
    createChart: function createChart(chartId, chartData) {
      var ctx = document.getElementById(chartId);
      this.myChart = new __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a(ctx, this.ChartData);
      console.log(this.myChart);
    },
    intervalChange: function intervalChange(interval) {
      this.interval = interval;
      console.log('changed interval:', this.interval);
      this.updateChart();
    },
    updateChart: function updateChart() {
      console.log('Update Chart:', this.interval, this.symbolFocus.pair, this.startDate);
      this.update = true;
      this.getCandles();
    },
    dateChange: function dateChange() {
      console.log('changed date:', this.startDate);
    },
    getCandles: function getCandles() {
      var _this = this;

      console.log('getting Candles');
      var url = 'https://us-central1-ftrworkscom.cloudfunctions.net/candles';
      var more = {
        symbol: this.symbolFocus.pair,
        interval: this.interval,
        limit: this.candlesAmount
      };
      console.log(more);
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(url, { params: more }).then(function (response) {
        _this.candles = response.data;
        _this.parseCandles();
        if (_this.update) {
          _this.myChart.update(_this.ChartData);
          console.log('updating');
          console.log(_this.myChart);
        } else {
          _this.createChart(_this.title, _this.ChartData);
          console.log('First Time');
        }
        return _this.candles;
      }).catch(function (error) {
        console.log(error);
        return error;
      });
    },
    parseCandles: function parseCandles() {
      console.log('Candles:', this.candles);
      for (var i = 0; i < this.candles.length; i++) {
        this.high[i] = parseFloat(this.candles[i].high);
        this.low[i] = parseFloat(this.candles[i].low);
        this.closes[i] = parseFloat(this.candles[i].open);
        this.open[i] = parseFloat(this.candles[i].close);
        var tempdate = new Date(this.candles[i].closeTime);
        this.candledate[i] = tempdate.toLocaleDateString();
      }
      this.ChartData.data.labels = this.candledate;
      this.ChartData.data.datasets[0].data = this.high;
      this.ChartData.data.datasets[1].data = this.low;
      console.log('Closes:', this.closes);
      console.log('Candle Dates:', this.candledate);
    }
  },
  /* eslint-enable no-unused-vars */
  mounted: function mounted() {
    console.log('Home - (mounted)');
    this.getCandles();
  }
});

/***/ }),

/***/ "lbH/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nbjv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return config; });
var config = {
  // Firebase FUD WORKS Config Info
  apiKey: 'AIzaSyD_fXvD4LGPGatE53XHDZl93EMlFyNx64c',
  authDomain: 'btr.works',
  databaseURL: 'https://btrworkscom.firebaseio.com',
  projectId: 'btrworkscom',
  storageBucket: 'btrworkscom.appspot.com',
  messagingSenderId: '1050456545258'
};

/***/ }),

/***/ "ozpK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

/* harmony default export */ __webpack_exports__["a"] = (function (value) {
  var pretty = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(value, null, 2);
  return pretty;
});

/***/ }),

/***/ "p6Vp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"variant":"warning"}},[_c('b-row',[_c('b-col',[_c('svg',{attrs:{"version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","preserveAspectRatio":"xMidYMid meet","viewBox":"0 350 500 250","height":"80"}},[_c('defs',[_c('path',{attrs:{"d":"M150 448.33L150 598.33L0 598.33L0 348.33L50 348.33L50 448.33L150 448.33ZM275 498.33L275 598.33L225 598.33L225 498.33L175 498.33L175 448.33L325 448.33L325 498.33L275 498.33ZM500 498.33L400 498.33L400 598.33L350 598.33L350 448.33L500 448.33L500 498.33ZM50 548.33L100 548.33L100 498.33L50 498.33L50 548.33Z","id":"logo"}})]),_vm._v(" "),_c('g',[_c('use',{staticClass:"logosvg",attrs:{"xlink:href":"#logo"}})])]),_vm._v(" "),_c('b-btn',{staticClass:"close",attrs:{"type":"button"},on:{"click":_vm.closeBox}},[_vm._v("\n        ╳")]),_vm._v(" "),_c('p',[_vm._v("Crypto made simple.")]),_vm._v(" "),_c('hr')],1)],1),_vm._v(" "),(_vm.content === 'first')?_c('btr-first',{on:{"happyclick":_vm.happyClick}}):_vm._e(),_vm._v(" "),(_vm.content === 'terms')?_c('btr-terms'):_vm._e(),_vm._v(" "),(_vm.content === 'about')?_c('btr-about'):_vm._e(),_vm._v(" "),(_vm.content === 'donate')?_c('btr-donate'):_vm._e(),_vm._v(" "),(_vm.content === 'disclaim')?_c('btr-disclaim'):_vm._e(),_vm._v(" "),(_vm.content === 'privacy')?_c('btr-privacy'):_vm._e(),_vm._v(" "),(_vm.content === 'addcoin')?_c('btr-addcoin'):_vm._e(),_vm._v(" "),(_vm.content === 'happyoffer')?_c('btr-happyoffer',{attrs:{"user":_vm.user}}):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),_c('b-row',{staticClass:"justify-content-md-center text-center"},[_c('b-col',{attrs:{"sm":"12","md":"2"}},[_c('svg',{attrs:{"aria-hidden":"true","preserveAspectRatio":"xMidYMid meet","width":"7.5vw","data-prefix":"fas","id":"smile","role":"img","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 496 512"}},[_c('path',{attrs:{"fill":"currentColor","d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 144c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.3-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm-160 0c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm80 280c-60.6 0-134.5-38.3-143.8-93.3-2-11.9 9.4-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"}})])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","md":"12","xl":"4"}},[_c('h3',[_vm._v(" Spread the Happiness ")]),_vm._v(" "),_c('btr-social'),_vm._v("\n      Happiness Tokens are an excellent way to get some practice receiving, sending and storing tokens with virtually no risk. \n    ")],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ppJm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_btr_chart_vue__ = __webpack_require__("kXGl");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d6c3a9e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_btr_chart_vue__ = __webpack_require__("fiXB");
function injectStyle (ssrContext) {
  __webpack_require__("HyLO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0d6c3a9e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_btr_chart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d6c3a9e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_btr_chart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qB1E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {},
  data: function data() {
    return {};
  },
  computed: {},
  created: function created() {},

  methods: {
    happyClick: function happyClick() {
      console.log('happyclick');
      this.$emit('happyclick');
    }
  },
  mounted: function mounted() {}
});

/***/ }),

/***/ "qSdX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d5262f90_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hello_vue__ = __webpack_require__("7CU6");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d5262f90_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hello_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qb6w":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rABr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67e62891_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_btr_terms_vue__ = __webpack_require__("O2cR");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67e62891_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_btr_terms_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "u6O7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"justify-content-md-center"},[_c('b-col',{attrs:{"cols":"8"}},[_c('h1',[_vm._v("Privacy")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',[_vm._v("Your privacy is important to BTR Works. This privacy statement provides \n    information about the personal information that BTR Works collects, \n    and the ways in which BTR Works uses that personal information. ")]),_vm._v(" "),_c('h5',[_vm._v("Credit")]),_vm._v(" "),_c('p',[_vm._v("This document was created using a Contractology template available at http://www.contractology.com.")]),_vm._v(" "),_c('h5',[_vm._v("Personal information collection")]),_vm._v(" "),_c('p',[_vm._v("BTR Works may collect and use the following kinds of personal information: ")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("information about your use of this website (including your IP address, \nreferral source and usage patterns);")]),_vm._v(" "),_c('li',[_vm._v("information that you provide using for the purpose of registering \nwith the website (including your name, email address, a BTR Works password \nand your Google credentials (if you opt for registration through Google);")]),_vm._v(" "),_c('li',[_vm._v("any dashboard data you choose to save within your BTR Works profile\n (including your list of tracked coins and any portfolio values entered);")]),_vm._v(" "),_c('li',[_vm._v("aggregated information about part or all of our user base, which may be formed\nusing some of your personal data;")]),_vm._v(" "),_c('li',[_vm._v("any other information that you send to BTR Works while communicating with us, \nasking questions or providing feedback.")])]),_vm._v(" "),_c('h5',[_vm._v("Using personal information")]),_vm._v(" "),_c('p',[_vm._v("BTR Works may use your personal information to: ")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("administer this website;")]),_vm._v(" "),_c('li',[_vm._v("personalize the website for you;")]),_vm._v(" "),_c('li',[_vm._v("enable your access to and use of the website services;")]),_vm._v(" "),_c('li',[_vm._v("ask you for feedback about the website;")]),_vm._v(" "),_c('li',[_vm._v("contact you about your BTR Works account and services (including customer service communications);")]),_vm._v(" "),_c('li',[_vm._v("analyze aggregate data about website usage;")]),_vm._v(" "),_c('li',[_vm._v("enforce any breaches of the BTR Works Terms;")]),_vm._v(" "),_c('li',[_vm._v("send you marketing communications.")])]),_vm._v(" "),_c('p',[_vm._v("Where BTR Works discloses your personal information to its agents or \nsub-contractors for these purposes, the agent or sub-contractor in question \nwill be obligated to use that personal information in accordance with the \nterms of this privacy statement. ")]),_vm._v(" "),_c('p',[_vm._v("In addition to the disclosures reasonably necessary for the purposes \nidentified elsewhere above, BTR Works may disclose your personal \ninformation to the extent that it is required to do so by law, \nin connection with any legal proceedings or prospective legal proceedings, \nand in order to establish, exercise or defend its legal rights.")]),_vm._v(" "),_c('h5',[_vm._v("Securing your data")]),_vm._v(" "),_c('p',[_vm._v("BTR Works will store all the personal information you provide on secured \n    servers. BTR Works will take reasonable technical and organisational \n    precautions to prevent the loss, misuse or alteration of your personal \n    information. Complete security of data transmitted over the internet or \n    electronically stored data is never possible. Therefore, we are not liable \n    for any unauthorized use, loss or theft of your personal data that \n    may occur outside of our reasonable control. ")]),_vm._v(" "),_c('h5',[_vm._v("Third Parties")]),_vm._v(" "),_c('p',[_vm._v("BTR Works may use third-party companies to support the services and \n    features of the website. These services may include: ")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Website hosting services;")]),_vm._v(" "),_c('li',[_vm._v("Data storage services;")]),_vm._v(" "),_c('li',[_vm._v("Cloud computing services;")]),_vm._v(" "),_c('li',[_vm._v("Authentication and messaging services.")])]),_vm._v(" "),_c('h5',[_vm._v("Cross-border data transfers")]),_vm._v(" "),_c('p',[_vm._v("Information that BTR Works collects may be stored and processed in and \ntransferred between any of the countries in which BTR Works operates to \nenable the use of the information in accordance with this privacy policy.")]),_vm._v(" "),_c('p',[_vm._v("You agree to such cross-border transfers of personal information.")]),_vm._v(" "),_c('h5',[_vm._v("Updating this statement")]),_vm._v(" "),_c('p',[_vm._v("BTR Works may update this privacy policy by posting a new version on this \nwebsite.  ")]),_vm._v(" "),_c('p',[_vm._v("You should check this page occasionally to ensure you are familiar with \n    any changes.  ")]),_vm._v(" "),_c('h5',[_vm._v("Other websites")]),_vm._v(" "),_c('p',[_vm._v("This website contains links to other websites.  ")]),_vm._v(" "),_c('p',[_vm._v("BTR Works is not responsible for the privacy policies or practices \n    of any third party.")]),_vm._v(" "),_c('h5',[_vm._v("Contact BTR Works")]),_vm._v(" "),_c('p',[_vm._v("If you have any questions about this privacy policy or BTR Works’ treatment of your personal information, please email: social@btr.works ")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "unug":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "vWPn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_btr_ticker_vue__ = __webpack_require__("aFrz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c01e558c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_btr_ticker_vue__ = __webpack_require__("IvaP");
function injectStyle (ssrContext) {
  __webpack_require__("56gR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c01e558c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_btr_ticker_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c01e558c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_btr_ticker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wlUl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_btr_donut_vue__ = __webpack_require__("LEDJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b46583c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_btr_donut_vue__ = __webpack_require__("Hz6k");
function injectStyle (ssrContext) {
  __webpack_require__("QJh3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7b46583c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_btr_donut_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b46583c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_btr_donut_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__("kxiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_components_Icon__ = __webpack_require__("D4uH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_firebaseConfig__ = __webpack_require__("nbjv");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// import * as cryptoicons from './cryptocurrency-icons/dist/'


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: __WEBPACK_IMPORTED_MODULE_1_vue_awesome_components_Icon__["a" /* default */],
  data: function data() {
    return {
      update: false,
      lastUpdated: '',
      socket: [],
      searchAsset: null,
      status: false,
      portfolio: [],
      walletList: [{
        name: '',
        address: '',
        type: ''
      }],
      baseCurr: {
        name: 'Bitcoin',
        symbol: 'BTC',
        exchange: 'Binance',
        data: {
          symbol: '',
          price: 1,
          percent: ''
        },
        amount: 0
      },
      user: {},
      settings: {
        lastupdated: '',
        debugBox: false,
        splashContent: 'first',
        splashBox: true,
        colorlist: ['rgba(255, 99, 132, 0.2)', 'rgba(54, 162, 235, 0.2)', 'rgba(255, 159, 64, 0.2)', 'rgba(0, 123, 0, 0.2)', 'rgba(200, 123, 200, 0.2)', 'rgba(0, 180, 180, 0.2)', 'rgba(0, 74, 74, 0.2)', 'rgba(220, 200, 74, 0.2)']
      }, // User Info
      assetsList: [], // Coin List
      asset: {
        name: '',
        symbol: '',
        exchange: '',
        data: {
          percent: 0
        },
        amount: 0,
        percent: 0,
        base: false,
        resolveTo: ''
      },
      userAssets: [],
      labels: [],
      signUpModal: false,
      logInModal: false
    };
  },

  computed: {
    menuItems: function menuItems() {
      var menuItems = [{ icon: 'face', title: 'Tour', link: '/signup' }, { icon: 'lock_open', title: 'Sign up', link: '/signin' }];
      if (this.userIsAuthenticated) {
        menuItems = [];
      }
      return menuItems;
    },
    userIsAuthenticated: function userIsAuthenticated() {
      return this.user !== null;
    }
  },
  methods: {
    changeUpdateState: function changeUpdateState(state) {
      this.update = !state;
    },
    openSplash: function openSplash(payload) {
      console.log('payload:', payload);
      this.settings.splashContent = payload.splashContent;
      this.settings.splashBox = payload.splashBox;
    },

    portfolioTotal: function portfolioTotal() {
      var total = 0;
      // console.log(this.activeUserAssets().length)
      if (this.userAssets.length > 0) {
        for (var i = 0; i < this.userAssets.length; i++) {
          if (this.userAssets[i].symbol === this.baseCurr.symbol) {
            this.userAssets[i].total = parseFloat(this.userAssets[i].amount);
          } else {
            this.userAssets[i].total = parseFloat(this.userAssets[i].data.price) * parseFloat(this.userAssets[i].amount);
          }
          total += this.userAssets[i].total;
        }
      }
      return total;
    },
    updateChart: function updateChart() {
      this.portfolio = this.userAssets.map(function (asset) {
        return asset.total;
      });
      this.labels = this.userAssets.map(function (asset) {
        return asset.name;
      });
      console.log('working out porfolio:', this.portfolio);
      this.update = true;
    },
    signUp: function signUp() {
      console.log('show signup modal');
      this.signUpModal = true;
    },
    login: function login() {
      console.log('show login modal');
      this.logInModal = true;
    },

    signIn: function signIn() {
      var _this = this;

      var provider = new __WEBPACK_IMPORTED_MODULE_0_firebase__["auth"].GoogleAuthProvider();
      __WEBPACK_IMPORTED_MODULE_0_firebase__["auth"]().signInWithPopup(provider).then(function (result) {
        _this.user = result.user;
        _this.status = true;
      }).catch(function (error) {
        return console.log(error);
      });
    },
    signOut: function signOut() {
      this.trashCollect();
      __WEBPACK_IMPORTED_MODULE_0_firebase__["auth"]().signOut();
    },
    trashCollect: function trashCollect() {
      console.log('collecting Trash');
      for (var i = 0; i < this.userAssets.length; i++) {
        this.removeUserAsset(i);
      }
    },
    addUserAsset: function addUserAsset() {
      var assetInfo = this.searchAsset;
      console.log('search ass:', this.searchAsset);
      assetInfo.data = {};
      assetInfo.amount = 0;
      assetInfo.state = true;
      var d = new Date();
      assetInfo.added = d.toString();
      console.log('Adding asset:', assetInfo);
      this.userAssets.push(assetInfo);
      this.addWebSocket(this.userAssets.length - 1); // not pretty should probably do this a different way
      this.searchAsset = null;
      this.updateChart();
    },
    removeUserAsset: function removeUserAsset(index) {
      if (this.userAssets[index].base) {
        console.log('keeping base');
      } else {
        console.log('DeActivating asset:', this.userAssets[index].name, index);
        this.userAssets[index].web.close();
        this.userAssets.splice(index, 1);
      }
      this.updateChart();
    },
    saveUserPortfolio: function saveUserPortfolio() {
      // save the user assets is good
      __WEBPACK_IMPORTED_MODULE_0_firebase__["database"]().ref('/user/' + this.user.uid + '/portfolio/').set(this.userAssets).then(function (data) {
        console.log('Returned:', data);
      }).catch(function (error) {
        console.log(error);
      });
    },
    saveUserSettings: function saveUserSettings() {
      var d = new Date();
      this.settings.updated = d.toString();
      this.settings.email = this.user.email;
      this.settings.displayName = this.user.displayName;
      __WEBPACK_IMPORTED_MODULE_0_firebase__["database"]().ref('/user/' + this.user.uid + '/settings/').set(this.settings).then(function (data) {
        console.log('Returned Settings:', data);
      }).catch(function (error) {
        console.log(error);
      });
    },
    loadUserPortfolio: function loadUserPortfolio() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_firebase__["database"]().ref('/user/' + this.user.uid + '/portfolio/').once('value').then(function (data) {
        if (data.val()) {
          console.log('Got User Data', data.val());
          _this2.trashCollect(); // clear out what ever is there
          _this2.userAssets = data.val(); // push the loaded stuff to local user assets
          _this2.setupSockets(); // set up new sockets
        } else {
          _this2.saveUserData(); // or if there is no data save whatever is in the local state to the database
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    loadUserSettings: function loadUserSettings() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0_firebase__["database"]().ref('/user/' + this.user.uid + '/settings/').once('value').then(function (data) {
        if (data.val()) {
          console.log('Got User Settings', data.val());
          _this3.settings = data.val(); // push the loaded stuff to local user assets
        } else {
          _this3.saveUserSettings(); // or if there is no data save whatever is in the local state to the database
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    loadUserData: function loadUserData() {
      this.loadUserSettings();
      this.getWalletList();
      this.loadUserPortfolio();
    },
    saveUserData: function saveUserData() {
      this.saveUserSettings();
      this.saveUserPortfolio();
    },
    loadDefaultData: function loadDefaultData() {
      this.userAssets = [{
        name: 'Bitcoin',
        symbol: 'BTC',
        exchange: 'Binance',
        data: {
          price: 0,
          percent: 0
        },
        amount: 0,
        base: true,
        resolveTo: 'USDT',
        link: ''
      }];
      console.log('Loaded Default Data:');
      this.setupSockets();
    },
    getWalletList: function getWalletList() {
      var _this4 = this;

      // this is good and clean
      console.log('Getting Wallet List');
      __WEBPACK_IMPORTED_MODULE_0_firebase__["database"]().ref('/user/' + this.user.uid + '/wallets').once('value').then(function (data) {
        console.log('back from the Database', data.val);
        // this.assetsList = data.val()
        var obj = data.val();
        var wallets = [];
        for (var key in obj) {
          wallets.push({
            id: key,
            name: obj[key].name,
            address: obj[key].address,
            type: obj[key].type
          });
        }
        _this4.walletList = wallets;
      }).catch(function (error) {
        console.log(error);
      });
    },
    getAssetsList: function getAssetsList() {
      var _this5 = this;

      // this is good and clean
      console.log('Getting Assets List');
      __WEBPACK_IMPORTED_MODULE_0_firebase__["database"]().ref('assets').once('value').then(function (data) {
        console.log('back from the Database', data.val);
        // this.assetsList = data.val()
        var obj = data.val();
        var assets = [];
        for (var key in obj) {
          assets.push({
            id: key,
            fullname: obj[key].name + ' (' + obj[key].symbol + ')',
            name: obj[key].name,
            symbol: obj[key].symbol,
            exchange: obj[key].exchange,
            resolveTo: obj[key].resolveTo,
            link: obj[key].link,
            note: obj[key].note,
            added: obj[key].added
          });
        }
        _this5.assetsList = assets;
      }).catch(function (error) {
        console.log(error);
      });
    },
    setupSockets: function setupSockets() {
      console.log('Setup the sockets:');
      for (var i = 0; i < this.userAssets.length; i++) {
        this.addWebSocket(i);
        // this.userAssets.total = parseFloat(this.userAssets[i].data.price) * parseFloat(this.userAssets[i].amount)
        // this.total += this.userAssets.total
      }
    },
    addWebSocket: function addWebSocket(index) {
      var _this6 = this;

      var quote = '';
      if (this.userAssets[index].symbol === this.baseCurr.symbol) {
        quote = this.userAssets[index].resolveTo;
      } else {
        quote = this.baseCurr.symbol;
      }
      var url = 'wss://stream.binance.com:9443/ws/' + this.userAssets[index].symbol.toLowerCase() + quote.toLowerCase() + '@ticker';
      console.log('websocket URL:', url);
      this.userAssets[index].web = new WebSocket(url);
      // this funky syntax below is to ensure you pass "this" into the websocket callback?
      this.userAssets[index].web.onopen = function (event) {
        console.log('Open this socket:', event);
      };
      this.userAssets[index].web.onclose = function (event) {
        console.log('closed socket:', event);
      };
      this.userAssets[index].web.onmessage = function (event) {
        // console.log('Tick:', index, event.data)
        var tick = JSON.parse(event.data);
        var d = new Date();
        _this6.userAssets[index].data = {
          price: parseFloat(tick.b),
          percent: parseFloat(tick.P),
          open: parseFloat(tick.o),
          close: parseFloat(tick.c),
          high: parseFloat(tick.h),
          low: parseFloat(tick.l),
          updated: d.toString()
        };
        _this6.lastUpdated = d;
        if (_this6.userAssets[index].symbol === _this6.baseCurr.symbol) {
          _this6.baseCurr.data = _this6.userAssets[index].data;
        }
        // console.log('got ticker:', index, this.userAssets[index].data)
        // document.title = this.tickerData.b + '|' + this.symbolFocus.pair
      };
    }
  },
  // //////////////////////////////////////////////////////////////////////////////
  // //////////////////////////////////////////////////////////////////////////////
  mounted: function mounted() {
    this.getAssetsList();
    setTimeout(this.updateChart, 1000);
    setInterval(this.updateChart, 60000);
    // this.setupSockets()
    // this.getBase(this.baseCurr.symbol, 'USDT') // hardwiring USDT is not nice... SORT
  },

  beforeCreate: function beforeCreate() {
    var _this7 = this;

    __WEBPACK_IMPORTED_MODULE_0_firebase__["initializeApp"](__WEBPACK_IMPORTED_MODULE_2__helpers_firebaseConfig__["a" /* config */]);
    __WEBPACK_IMPORTED_MODULE_0_firebase__["auth"]().onAuthStateChanged(function (response) {
      if (response) {
        _this7.user = response;
        // LOAD EXISING ACCOUNTS HERE
        _this7.status = true;
        console.log('Got a User');
        console.log('Userdata', _this7.user);
        // load user info !!!!!!!!!!!!!!!!!!!!!!
        _this7.loadUserPortfolio();
        _this7.getWalletList();
        _this7.loadUserSettings();
      } else {
        console.log('No User');
        _this7.user = null;
        _this7.status = false;
        _this7.loadDefaultData();
      }
    });
  }
});

/***/ }),

/***/ "zj2Q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.dc5cae5c73a2ff27ed9c.js